// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for NL (Nederlands)
 * @file translations.nl.js
 * @description Main application translations for nl
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsNl = {
                'login.title': 'Inloggen',
                'login.slogan': 'Gesprekken zonder grenzen!',
                'login.username': 'Gebruikersnaam',
                'login.password': 'Wachtwoord',
                'login.submit': 'Inloggen',
                'login.loading': 'Laden...',
                'login.autoRegister.title': 'Automatische registratie',
                'login.autoRegister.description': 'Als je nog geen account hebt, voer je je gebruikersnaam, wachtwoord en e-mail in. Het account wordt automatisch aangemaakt en je ontvangt een bevestigingslink per e-mail.',
                'login.forgotPassword': 'Wachtwoord vergeten?',
                'login.passwordRecovery.title': 'Wachtwoord herstellen',
                'login.passwordRecovery.description': 'Voer je e-mailadres in om een herstellink te ontvangen.',
                'login.passwordRecovery.emailLabel': 'E-mail',
                'login.passwordRecovery.emailPlaceholder': 'Voer je e-mailadres in',
                'login.passwordRecovery.emailHelp': 'Er wordt een herstellink naar je e-mail verstuurd',
                'login.passwordRecovery.send': 'Verzenden',
                'login.passwordRecovery.success': 'Er is een herstellink naar je e-mail verstuurd. Controleer je inbox.',
                'login.passwordRecovery.successTitle': 'E-mail verzonden',
                'login.passwordRecovery.successMessage': 'We hebben je een e-mail gestuurd met instructies om je wachtwoord opnieuw in te stellen.\nControleer je inbox en de spammap. De link kan enkele minuten nodig hebben.',
                'login.passwordRecovery.devExplanation': 'In ontwikkelmodus wordt de e-mail niet naar je inbox verstuurd; deze wordt opgeslagen voor preview. Gebruik "E-mail bekijken" om de inhoud en de herstellink te zien.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Ontwikkelmodus: deze e-mail is NIET naar je inbox verstuurd. Gebruik "E-mail bekijken" om het gegenereerde bericht te openen en de link te gebruiken.',
                'login.passwordRecovery.invalidEmail': 'Voer een geldig e-mailadres in',
                'login.error.invalidPassword': 'Ongeldig wachtwoord',
                'auth.require_email': 'E-mail is verplicht om de registratie te voltooien. Voer je e-mailadres in.',
                'auth.invalid_credentials': 'Onjuiste gebruikersnaam of wachtwoord.',
                'auth.user_not_found': 'Gebruiker niet gevonden.',
                'auth.user_inactive': 'Je account is gedeactiveerd. Neem contact op met de beheerder.',
                'auth.account_blocked': 'Account is inactief. Voer je e-mail in om het opnieuw te activeren.',
                'auth.device_limit_reached': 'Apparaatlimiet bereikt. Meld je af op een ander apparaat of upgrade je plan.',
                'auth.login.device_limit.title': 'Sessie- of apparaatlimiet bereikt',
                'auth.login.device_limit.body': 'Je abonnement staat een beperkt aantal gelijktijdig actieve sessies of apparaten toe. Meld je op een ander apparaat af of sluit een andere actieve sessie en probeer het opnieuw.',
                'auth.password_incorrect': 'Het wachtwoord is onjuist.',
                'auth.login.password_error_title': 'Onjuist wachtwoord',
                'auth.login.password_attempts_hint': 'Je hebt 3 pogingen om je wachtwoord correct in te voeren. Als je die overschrijdt, moet je je wachtwoord opnieuw instellen.',
                'auth.login.password_attempts_exhausted_title': 'Pogingslimiet bereikt',
                'auth.login.password_attempts_exhausted_body': 'Je hebt de 3 toegestane pogingen overschreden. Stel je wachtwoord opnieuw in via «Wachtwoord vergeten?».',
                'auth.login.go_to_reset_password': 'Ga naar wachtwoord resetten',
                'auth.login.password_remaining_two': 'Je hebt nog 2 pogingen over.',
                'auth.login.password_remaining_one': 'Je hebt nog 1 poging over.',
                'auth.login.password_attempts_locked_inline': 'Maximum aantal pogingen bereikt. Je moet je wachtwoord opnieuw instellen.',
                'auth.account_inactive_email_mismatch': 'Account is inactief en het e-mailadres komt niet overeen.',
                'auth.captcha_failed': 'CAPTCHA is onjuist. Controleer je antwoord.',
                'auth.captcha_expired': 'Uw verificatie is verlopen. Er is automatisch een nieuwe gegenereerd.',
                'auth.unauthorized': 'Je hebt geen toegangsrechten.',
                'auth.generic_error': 'Er is een fout opgetreden. Probeer het opnieuw.',
                'auth.method_not_allowed': 'Methode niet toegestaan.',
                'auth.invalid_data': 'Ongeldige gegevens.',
                'auth.credentials_required': 'Gebruikersnaam en wachtwoord zijn verplicht.',
                'auth.csrf_invalid': 'Ongeldige sessie. Laad de pagina opnieuw en probeer het nog eens.',
                'auth.username_taken': 'Die gebruikersnaam is al geregistreerd. Meld je aan of kies een andere.',
                'auth.username_unavailable': 'Die gebruikersnaam is niet beschikbaar.',
                'auth.nick_no_spaces': 'Bijnamen mogen geen spaties bevatten.',
                'auth.password_too_short': 'Wachtwoord moet minimaal 6 tekens zijn.',
                'auth.password_mismatch': 'Wachtwoorden komen niet overeen.',
                'auth.rate_limit': 'Te veel pogingen. Wacht even en probeer het opnieuw.',
                'auth.confirm_success': 'Account succesvol bevestigd. Doorsturen naar inloggen...',
                'auth.confirm_already_active': 'Je account is al actief. Je kunt inloggen.',
                'auth.reset_sent': 'Als het e-mailadres geregistreerd is, ontvang je instructies om je wachtwoord opnieuw in te stellen.',
                'auth.reset_token_invalid': 'Ongeldige of ontbrekende link.',
                'auth.reset_token_expired': 'Deze link is verlopen. Vraag een nieuwe aan via «Wachtwoord vergeten?».',
                'auth.reset_done': 'Wachtwoord bijgewerkt. Je kunt nu inloggen.',
                'auth.reset_fatal': 'Fout bij opslaan. Probeer het later opnieuw.',
                'resetPassword.page.title': 'Nieuw wachtwoord',
                'resetPassword.page.description': 'Voer je nieuwe wachtwoord in (minimaal 6 tekens).',
                'resetPassword.newPassword': 'Nieuw wachtwoord',
                'resetPassword.newPasswordPlaceholder': 'Minimaal 6 tekens',
                'resetPassword.submit': 'Wachtwoord resetten',
                'resetPassword.success': 'Wachtwoord bijgewerkt. Doorsturen naar inloggen...',
                'resetPassword.backToLogin': 'Terug naar inloggen',
                'mail.send_failed': 'Herstele-mail kon niet worden verstuurd. Controleer SMTP-configuratie of probeer het later opnieuw.',
                'auth.register_success_email_sent': 'Account succesvol aangemaakt. Er is een bevestigingsmail verstuurd. Controleer je inbox (en spam) en klik op de link om je account te activeren.',
                'auth.register_success_email_pending': 'Account succesvol aangemaakt, maar er was een probleem bij het versturen van de bevestigingsmail. Het activatietoken is nog geldig. Neem contact op met de beheerder of vraag een nieuwe bevestigingsmail aan.',
                'auth.email_not_verified': 'Je moet je e-mail bevestigen om je account te activeren.',
                'auth.email_not_verified_title': 'Account wacht op bevestiging',
                'auth.email_send_failed': 'We konden de e-mail niet versturen. Probeer het opnieuw of wijzig je e-mail.',
                'auth.email_send_failed_title': 'E-mail kon niet worden verstuurd',
                'auth.register.email_failed.title': 'Account aangemaakt',
                'auth.register.email_failed.message': 'Je account is succesvol aangemaakt, maar er was een probleem bij het versturen van de bevestigingsmail. Controleer spam of vraag een nieuwe e-mail aan.',
                'auth.register.success.title': 'Account aangemaakt',
                'auth.register.success.message': 'Account succesvol aangemaakt. Er is een bevestigingsmail verstuurd. Controleer je inbox (en spam) en klik op de link om je account te activeren.',
                'auth.resend_sent': 'Bevestigingsmail opnieuw verstuurd.',
                'auth.resend_email': 'E-mail opnieuw versturen',
                'auth.retry_resend': 'Opnieuw proberen',
                'auth.change_email': 'E-mail wijzigen',
                'auth.ver_email': 'E-mail bekijken',
                'auth.already_verified': 'Account is al geverifieerd.',
                'auth.pending_activation.title': 'Account wacht op activatie',
                'auth.pending_activation.body': 'Je account is nog niet geactiveerd. Controleer je inbox en bevestig je registratie om in te loggen op ArChat.',
                'auth.pending_activation.back_to_login': 'Terug naar inloggen',
                'auth.pending_activation.support_prefix': 'Hulp nodig? Neem contact op met support:',
                "auth.pending_activation.support_email": "info@archat.com.ar",
                'auth.pending_activation.email_label': 'E-mail om activatie opnieuw te versturen',
                'auth.pending_activation.email_placeholder': 'jij@email.com',
                'auth.pending_activation.email_required': 'Voer het e-mailadres in waarmee je je hebt geregistreerd om activatie opnieuw te versturen.',
                'auth.pending_activation.sent_title': 'Activeeringsmail verstuurd',
                'auth.pending_activation.sent_body': 'Als het adres overeenkomt met een pending account, hebben we een nieuwe activatielink gestuurd. Controleer inbox en spam.',
                'auth.pending_activation.soft_error_title': 'Opnieuw versturen niet beschikbaar',
                'auth.pending_activation.soft_error_body': 'We konden het opnieuw versturen nu niet verwerken. Probeer over een paar minuten opnieuw of neem contact met ons op via info@archat.com.ar.',
                'auth.pending_activation.resend_again': 'Opnieuw versturen',
                'auth.confirm_email_title': 'Bevestig e-mail',
                'auth.confirm_email_text': 'De activatielink wordt verzonden naar:',
                'auth.confirm_email_edit': 'Bewerken',
                'auth.confirm_email_confirm': 'Bevestigen',
                'auth.confirm_email_typo_hint': 'Bedoelde u ***@{suggestion}?',
                'brand.slogan': 'De kracht om begrepen te worden, ongeacht de taal',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'De kracht om begrepen te worden, ongeacht de taal',
                'home.tagline': 'Berichten met automatische vertaling',
                'home.login': 'Inloggen',
                'home.register': 'Account aanmaken',
                'home.language': 'Taal',
                'terms.title': 'Algemene voorwaarden',
                'terms.accept': 'Accepteren en doorgaan',
                'terms.reject': 'Weigeren',
                'terms.rejectShort': 'Ik accepteer niet',
                'terms.readAndAccept': 'Ik heb de algemene voorwaarden gelezen en accepteer ze',
                'terms.cancel': 'Annuleren',
                'register.pageTitle': 'Account aanmaken',
                'register.pageSubtitle': 'Vul je gegevens in om je account aan te maken.',
                'register.submitLabel': 'Account aanmaken',
                'register.confirm_title': 'Account bevestigen',
                'register.confirm_message': 'Je staat op het punt het volgende account aan te maken:',
                'register.confirm': 'Bevestigen',
                'register.login_link': 'Heb je al een account?',
                'register.password_hint': 'Minimaal 6 tekens',
                'register.checking': 'Controleren…',
                'register.username_taken': 'Deze gebruikersnaam is al in gebruik.',
                'register.available': 'Beschikbaar',
                'register.emailAlreadyExists': 'Dit e-mailadres is al geregistreerd.',
                'register.continue': 'Doorgaan',
                'login.demo.title': 'Demo-toegang',
                'login.demo.credentials': 'Gebruiker: demo / Wachtwoord: demo',
                'common.language': 'Taal',
                'common.loading': 'Laden…',
                'common.back': 'Terug',
                'common.backToStart': 'Terug naar startpagina',
                'common.changeUser': 'Gebruiker wijzigen',
                'common.request_id_label': 'Verzoek-ID',
                'login.email.invalid': 'Voer een geldig e-mailadres in',
                'captcha.solve': 'Los de CAPTCHA correct op',
                'captcha.generateError': 'Fout bij het genereren van CAPTCHA. Laad de pagina opnieuw.',
                'captcha.label': 'Beveiligingscontrole',
                'captcha.description': 'Los de rekenoplossing op om te verifiëren dat je een mens bent',
                'captcha.required': 'U moet het CAPTCHA-antwoord invoeren om door te gaan.',
                'menu.conversations': 'Gesprekken',
                'menu.contacts': 'Contacten',
                'menu.dashboard': 'Overzicht',
                'menu.admin': 'Beheer',
                'menu.profile': 'Mijn profiel',
                'menu.settings': 'Instellingen',
                'menu.help': 'Hulp',
                'menu.logout': 'Afmelden',

                // MVP "Mis archivos"
                'menu.files': 'Mijn bestanden',
                'reviews.menu_title': 'Beoordelingen',
                'reviews.rate_archat': 'ArChat beoordelen',
                'reviews.my_review': 'Mijn beoordeling',
                'files.title': 'Mijn bestanden',
                'files.filter_all': 'Alles',
                'files.filter_sent': 'Verzonden',
                'files.filter_received': 'Ontvangen',
                'files.filter_images': 'Afbeeldingen',
                'files.filter_documents': 'Documenten',
                'files.col_name': 'Naam',
                'files.col_size': 'Grootte',
                'files.col_date': 'Datum',
                'files.col_direction': 'Richt.',
                'files.col_actions': 'Acties',
                'files.sent': '📤 Verzonden',
                'files.received': '📥 Ontvangen',
                'files.download': 'Downloaden',
                'files.delete_for_me': 'Verwijder voor mij',
                'files.delete_confirm_title': 'Bestand verwijderen',
                'files.delete_confirm_message': 'Dit bestand wordt verwijderd uit uw account. Het wordt niet verwijderd voor de andere persoon. Doorgaan?',
                'files.empty': 'Je hebt geen bestanden.',
                'files.error_loading': 'Fout bij het laden van bestanden.',
                'files.unavailableForFree': 'Mijn bestanden zit niet in het FREE-abonnement.',
                'files.availableInFoundationAndPro': 'Mijn bestanden is beschikbaar bij FOUNDATION en PRO.',
                'files.filesFeatureRestricted': 'Deze functie is niet beschikbaar op je huidige abonnement.',
                'files.filesLoadError': 'Fout bij het laden van bestanden.',
                'files.uploadUnavailableForFree': 'Verzenden van bestanden is niet beschikbaar in het FREE-abonnement.',
                'files.uploadAvailableInFoundationAndPro': 'Bestanden verzenden is beschikbaar in FOUNDATION en PRO.',
                'files.recipientStorageFull': 'De ontvanger heeft geen vrije ruimte om dit bestand te ontvangen.',
                'files.recipientNoAvailableStorage': 'De ontvanger heeft geen vrije ruimte om dit bestand te ontvangen.',
                'files.storageQuotaExceeded': 'Je hebt de opslaglimiet van je abonnement bereikt.',
                'files.freeStorageLimit': 'Het FREE-abonnement omvat 5 MB opslag voor ontvangen bestanden.',
                'files.load_more': 'Meer laden',
                'onboarding.welcome_title': 'Welkom bij ArChat®',
                'onboarding.welcome_subtitle': 'Communiceer met iedereen in elke taal.',
                'onboarding.step1': 'Stap 1',
                'onboarding.step1_title': 'Stap 1',
                'onboarding.step1_description': 'Nodig je eerste contact uit',
                'onboarding.step2': 'Stap 2',
                'onboarding.step2_title': 'Stap 2',
                'onboarding.step2_description': 'Verstuur je eerste bericht',
                'onboarding.invite_contact': 'Contact uitnodigen',
                'onboarding.explore_archat': 'ArChat® verkennen',
                'contacts.invite_contact': 'Contact uitnodigen',
                'help.view_initial_guide': 'Bekijk de startgids',
                'suggestions.title': 'Suggesties',
                'suggestions.form.title': 'Titel van de suggestie',
                'suggestions.form.message': 'Beschrijf je idee',
                'suggestions.form.submit': 'Suggestie versturen',
                'suggestions.send': 'Suggestie versturen',
                'suggestions.success': 'Bedankt voor je suggestie. Ons team zal deze bekijken.',
                'suggestions.success.title': 'Bedankt voor je suggestie!',
                'suggestions.success.reference': 'Referentie',
                'suggestions.success.review': 'Ons team zal je idee bekijken.',
                'suggestions.success.email': 'We hebben je ook een bevestigingsmail gestuurd.',
                'suggestions.success.copy': 'Kopiëren',
                'suggestions.success.copied': 'Referentie gekopieerd',
                'suggestions.form.required': 'Titel en bericht zijn verplicht.',
                'suggestions.error': 'Verzenden mislukt. Probeer het opnieuw.',
                'profile.title': 'Mijn profiel',
                'profile.founderBadge': 'Oprichter #{position}/{limit}',
                'profile.founderTooltip': 'Oprichter Lid – Levenslang bevroren prijs zolang het abonnement actief blijft',
                'profile.founderMember': 'Oprichter Lid',
                'profile.founderHeaderBadge': '★ Oprichter #{position}/150',
                'profile.camera.access_denied': 'Geen toegang tot de camera. Controleer machtigingen.',
                "profile.edit": "Bewerking",
                "profile.save": "Wijzigingen opslaan",
                "profile.save.success": "Uw profiel is succesvol bijgewerkt.",
                "profile.save.success.title": "Bijgewerkt profiel",
                "profile.update.success.title": "Bijgewerkt profiel",
                "profile.update.success.message": "Uw wijzigingen zijn succesvol opgeslagen.",
                "profile.save.error": "Kan profiel niet updaten. Probeer het opnieuw.",
                "profile.save.error.title": "Fout bij opslaan",
                "profile.cancel": "Annuleren",
                'profile.nick': 'Gebruikersnaam',
                "profile.nick.help": "Uw unieke identificatie in het systeem",
                "profile.nick.readonly": "Gebruikersnaam kan niet worden gewijzigd",
                "profile.nick.readonly.help": "De gebruikersnaam is uniek en kan niet worden gewijzigd",
                "profile.email.readonly": "De e-mail kan niet worden gewijzigd",
                "profile.email.readonly.help": "De e-mail is uniek en kan niet worden gewijzigd",
                "profile.name": "Echte naam",
                "profile.lastname": "Achternaam",
                "profile.alias": "Alias",
                "profile.email": "E-mail",
                "profile.phone": "Telefoon",
                "profile.language": "Taal",
                "profile.country": "Land",
                "profile.country.select": "Selecteer land",
                "profile.biography": "Biografie",
                'bio.modal.original': 'Origineel',
                'bio.modal.translation': 'Vertaling',
                'bio.modal.empty': 'Deze contactpersoon heeft geen biografie.',
                'bio.modal.translating': 'Bezig met vertalen...',
                'bio.modal.translation_error': 'De biografie kon niet worden vertaald.',
                'attachment.unnamed_file': 'Bestand',
                'auth.login_error.default_title': 'Toegangsfout',
                'auth.login_error.default_message': 'Aanmelden mislukt.',
                "profile.photo": "Profielfoto",
                'notifications.bell.aria': 'Meldingen',
                'notifications.panel.title': 'Meldingen',
                'notifications.empty': 'Geen meldingen',
                'notifications.mark_read': 'Markeren als gelezen bij openen',
                'profile.notifications.sound': 'Notificatiegeluid',
                'profile.notifications.sound_desc': 'Geluid afspelen bij nieuwe berichten of belangrijke meldingen',
                "profile.plan.upgrade.button": "Upgrade naar PRO",
                'profile.plan.upgrade.hint': 'Access all features without limits',
                'billing.change_plan': 'Van plan wijzigen',
                "billing.usage.title": "Gebruik plannen",
                "billing.usage.users": "Gebruikers",
                "billing.usage.messages": "Berichten (vandaag)",
                "billing.usage.invitations": "Uitnodigingen (vandaag)",
                "billing.usage.messages_month": "Berichten deze maand",
                "billing.usage.chats": "Gesprekken",
                'billing.usage.warning': 'You are approaching your plan limit. Upgrade to PRO for more capacity.',
                'plans.limit.reached': 'Limiet bereikt — Upgrade plan',
                "profile.theme.dark": "Donkere modus",
                "modal.title": "Kwalificatie",
                "modal.success.title": "Succes",
                "modal.error.title": "Fout",
                "modal.warning.title": "Waarschuwing",
                "info.title": "Informatie",
                "appearance.title": "Verschijning",
                "appearance.theme.light": "Duidelijk",
                "appearance.theme.dark": "Donker",
                "theme.title": "Probleem",
                "theme.light": "Duidelijk",
                "theme.dark": "Donker",
                "profile.photo.section": "Profielfoto",
                "profile.personalInfo": "Persoonlijke informatie",
                "profile.preferences": "Voorkeuren",
                "profile.country.help": "De tijdzone wordt automatisch toegewezen op basis van het geselecteerde land",
                "profile.lastname.placeholder": "Uw achternaam (optioneel)",
                "profile.name.placeholder": "Je echte naam (optioneel)",
                "profile.biography.placeholder": "Vertel ons over jezelf...",
                "profile.plan.title": "Abonnementsplan",
                "profile.plan.current": "Uw huidige abonnement",
                'profile.plan.free.description': 'Free plan with limitations. Upgrade to PRO for full access.',
                'profile.plan.pro.description': 'You have full access to all features.',
                "profile.photo.change": "Profielfoto wijzigen",
                "message.placeholder": "Schrijf een bericht...",
                "message.placeholderWithFile": "Bestand verzenden",
                "message.sent_from_country": "Verzonden vanaf",
                "message.sent_at_local_time": "Lokale tijd van de uitgever",
                "message.timezone_label": "tijdzone",
                "message.context_info": "Dit bericht behoudt de tijdscontext van het tijdstip waarop het werd verzonden.",
                "message.context_pro_hint": "Voor dit bericht zijn tijd en geografische context beschikbaar in Pro-abonnementen.",
                "message.context_pro_badge": "Context Pro",
                "attachment.title": "Bestand bijvoegen",
                "attachment.close": "Dichtbij",
                "attachment.gallery": "Foto-/videogalerij",
                "attachment.cameraFront": "camera aan de voorkant",
                "attachment.cameraBack": "achteruitrijcamera",
                "attachment.cameraWeb": "webcam",
                "attachment.selectFile": "Bestand selecteren (PDF, tekst, afbeeldingen, video's)",
                "attachment.remove": "Elimineren",
                "attachment.audioNotSupported": "Audioberichten worden niet ondersteund in ArChat®. Stuur dan een schriftelijk bericht.",
                "message.audioDeprecated.title": "Spraakbericht niet ondersteund",
                "message.audioDeprecated.message": "Dit spraakbericht wordt niet langer ondersteund door ArChat®. Stuur dan een schriftelijk bericht.",
                "camera.title": "Camera",
                "camera.close": "Dichtbij",
                "camera.switch": "Camera wijzigen",
                "camera.capture": "Maak een foto",
                "camera.loading": "Camera starten...",
                "camera.retry": "Opnieuw proberen",
                "camera.error.access": "Er was geen toegang tot de camera. Controleer machtigingen.",
                "camera.error.permission": "Camerarechten geweigerd. Geef toegang tot de camera in uw browserinstellingen.",
                "camera.error.notFound": "Geen beschikbare camera gevonden.",
                "camera.error.busy": "De camera wordt gebruikt door een andere applicatie.",
                "camera.error.constraint": "Er kan niet worden voldaan aan camerabeperkingen.",
                "profile.photo.take": "Maak een foto",
                "profile.photo.gallery": "Kies uit galerij",
                "profile.photo.select": "Selecteer foto",
                "profile.photo.select.gallery": "Kies uit galerij",
                "profile.photo.uploading": "Afbeelding uploaden...",
                "profile.photo.upload.success": "Profielfoto bijgewerkt",
                "profile.photo.upload.success.title": "Bijgewerkte foto",
                "profile.photo.upload.error": "Fout bij het uploaden van profielfoto. Probeer het opnieuw.",
                "profile.photo.upload.error.title": "Fout bij het uploaden van foto",
                "profile.photo.take.front": "camera aan de voorkant",
                "profile.photo.take.back": "achteruitrijcamera",
                "profile.photo.take.webcam": "webcam",
                "profile.photo.capture": "Vastlegging",
                "user.default": "Gebruiker",
                "logout.title": "Bevestigen",
                "logout.confirm": "Weet u zeker dat u wilt uitloggen?",
                "block.toggle_error": "Kon niet vergrendelen of ontgrendelen.",
                'contacts.title': 'Contacten',
                'contacts.search': 'Contact zoeken',
                'contacts.sort': 'Sorteren',
                'contacts.sortByName': 'Op naam',
                'contacts.sortByStatus': 'Op status',
                'contacts.sortByRecent': 'Meest recent',
                'contacts.filter': 'Filteren',
                'contacts.filterAll': 'Alle',
                'contacts.filterAvailable': 'Beschikbaar',
                'contacts.filterInvited': 'Uitgenodigd',
                'contacts.filterBlocked': 'Geblokkeerd',
                'contacts.pending_invitations': 'Openstaande uitnodigingen',
                'contacts.status.invitation_sent': 'Uitnodiging verzonden',
                'contacts.conversations': 'Gesprekken',
                'contacts.search_contact': 'Contact zoeken',
                "contacts.search.placeholder": "Zoek op gebruikersnaam, voornaam, achternaam, land of taal...",
                "contacts.empty": "Er zijn geen contacten",
                "contacts.empty.title": "Je hebt nog steeds geen contacten",
                "contacts.empty.message": "Nodig uit of maak er een aan om aan de slag te gaan.",
                "contacts.empty.invite_button": "Nodig een contactpersoon uit",
                "contacts.empty.private.message": "Je profiel is privé. Nodig contacten uit om te beginnen met chatten.",
                "contacts.empty.private.invite_button": "Nodig een contactpersoon uit",
                "contacts.search.no_results": "Geen contacten gevonden",
                "contacts.search.clear": "Toon alles",
                'contacts.controls.search_placeholder': 'Contact zoeken...',
                'contacts.controls.search_label': 'Contact zoeken',
                'contacts.controls.sort_label': 'Sorteren op',
                'contacts.controls.sort.name': 'Naam',
                "contacts.controls.sort.status": "Staat",
                "contacts.controls.sort.recent": "Recent",
                'contacts.controls.sort.manual': 'Handmatig',
                'contacts.controls.sort.manual_drag_hint': 'Sleep om te herschikken',
                "contacts.controls.filter_label": "Staat",
                'contacts.controls.filter.all': 'Alle',
                'contacts.controls.filter.available': 'Beschikbaar',
                'contacts.controls.filter.invited': 'Uitgenodigd',
                'contacts.controls.filter.blocked': 'Geblokkeerd',
                'contacts.controls.filter.favorites': 'Favorieten',
                'contacts.nick': 'Gebruikersnaam',
                "contacts.name": "Naam",
                "contacts.lastname": "Achternaam",
                "contacts.country": "Land",
                "contacts.language": "Taal",
                "contacts.status": "Staat",
                'status.available': 'Beschikbaar',
                'status.busy': 'Bezet',
                'status.in_call': 'In gesprek',
                'status.away': 'Afwezig',
                "status.offline": "Offline",
                'status.custom': 'Aangepast bericht',
                'status.set_title': 'Beschikbaarheidsstatus',
                'status.set_button': 'Status wijzigen',
                'status.placeholder': 'Optioneel bericht (bijv. In vergadering)',
                "contacts.status.pending_registration": "Registratie in behandeling",
                "contacts.status.registered": "Gast - Geregistreerd",
                "contacts.status.ready_to_chat": "Klaar om te chatten",
                "contacts.status.active_conversation": "Actief gesprek",
                "contacts.invitation.pending.title": "Uitnodiging in behandeling",
                "contacts.invitation.pending.message": "Deze uitnodiging wacht op registratie. De contactpersoon ontvangt een e-mail om de registratie te voltooien. Eenmaal geregistreerd, kunt u met hem chatten.",
                "contacts.error.no_registered": "De contactpersoon is nog niet geregistreerd. Wacht tot uw registratie is voltooid.",
                "contact.edit.title": "Contactpersoon bewerken",
                "contact.edit.alias.label": "Aangepaste alias",
                "contact.edit.alias.placeholder": "Bijvoorbeeld: Juan van zijn werk",
                "contact.edit.alias.help": "Deze naam verschijnt in plaats van de echte naam",
                "contact.edit.nota.label": "Persoonlijke noot",
                "contact.edit.nota.placeholder": "Voeg een notitie toe over dit contact...",
                "contact.edit.nota.help": "Privénotities zijn alleen voor jou zichtbaar",
                "contact.edit.error.noUser": "Fout: onbekende gebruiker",
                "contact.edit.error.noContactId": "Fout: contactpersoon kon niet worden geïdentificeerd",
                "contact.edit.error.save": "Fout bij opslaan",
                "contact.limit.title": "Contactlimiet bereikt",
                "contact.limit.message": "Met het GRATIS abonnement zijn maximaal 2 contacten per gebruiker mogelijk. U kunt upgraden naar FOUNDATION of PRO voor meer capaciteit wanneer opladen is ingeschakeld.",
                "conversation.backToContacts": "Terug naar contacten",
                "help.title": "ArChat®-hulp",
                "help.howWorks.title": "👥 Hoe ArChat® werkt (echte flow)",
                "help.howWorks.step1.title": "1️⃣ Registratie",
                "help.howWorks.step1.point1": "Log in met uw gebruikersnaam en wachtwoord.",
                "help.howWorks.step1.point2": "Als u geen account heeft, wordt deze automatisch aangemaakt.",
                "help.howWorks.step1.point3": "U accepteert de Algemene Voorwaarden in uw taal.",
                "help.howWorks.step1.point4": "U bevestigt uw account per e-mail.",
                "help.howWorks.step2.title": "2️⃣ Privé-uitnodigingen",
                "help.howWorks.step2.point1": "Nodig contacten uit per e-mail vanuit uw profiel.",
                "help.howWorks.step2.point2": "Definieer de taal en gespreksmodus voordat u begint.",
                "help.howWorks.step2.point3": "De contactpersoon ontvangt een privé-uitnodiging.",
                "help.howWorks.step2.point4": "Je kunt zien of het: In behandeling, Geregistreerd, Klaar om te chatten is",
                "help.howWorks.step2.point5": "Contacten worden niet gezocht, maar uitgenodigd.",
                "help.howWorks.step2.point6": "Contacten worden niet gezocht, maar uitgenodigd.",
                "help.howWorks.step3.title": "3️⃣ Contacten en gesprekken",
                "help.howWorks.step3.point1": "Uw contacten verschijnen automatisch wanneer:",
                "help.howWorks.step3.point2": "accepteer een uitnodiging",
                "help.howWorks.step3.point3": "of er is een gesprek",
                "help.howWorks.step3.point4": "Kan:",
                "help.howWorks.step3.point5": "markeer ze als favorieten ⭐",
                "help.howWorks.step3.point6": "wijs ze aangepaste aliassen toe",
                "help.howWorks.step3.point7": "privénotities toevoegen",
                "help.howWorks.step3.point8": "blokkeren of beheren",
                "help.howWorks.step3.point9": "Er is geen publieke agenda of zichtbare gebruikers zonder toestemming.",
                "help.howWorks.step4.title": "4️⃣ Berichten met vertaling",
                "help.howWorks.step4.point1": "Schrijf altijd in uw taal.",
                "help.howWorks.step4.point2": "Het systeem vertaalt het bericht automatisch.",
                "help.howWorks.step4.point3": "De ontvanger ontvangt het in zijn taal.",
                "help.howWorks.step4.point4": "U kunt de vertaling toegepast zien.",
                "help.howWorks.step4.point5": "Als een vertaling mislukt, wordt deze automatisch opnieuw geprobeerd.",
                "help.howWorks.step4.point6": "ArChat® geeft prioriteit aan duidelijkheid en betekenis, niet alleen aan snelheid.",
                "help.privacy.title": "🔒 Privacy en controle",
                "help.privacy.point1": "Uw profiel is standaard privé.",
                "help.privacy.point2": "Alleen degenen die u uitnodigt, kunnen u zien of schrijven.",
                "help.privacy.point3": "Openbare zichtbaarheid is optioneel en standaard uitgeschakeld.",
                "help.privacy.point4": "Actieve veiligheid met:",
                "help.privacy.point5": "CAPTCHA",
                "help.privacy.point6": "snelheidsbeperking",
                "help.privacy.point7": "vingerafdruk",
                "help.privacy.point8": "e-mailverificatie",
                "help.privacy.point9": "Je gesprekken zijn niet openbaar of geïndexeerd.",
                "help.files.title": "📎 Bestanden en exporteren",
                "help.files.point1": "Voeg afbeeldingen, video's en PDF-documenten toe.",
                "help.files.point2": "Maak foto's met de camera aan de voorkant, de camera aan de achterkant of de webcam.",
                "help.files.point3": "Afbeeldingen worden automatisch gecomprimeerd.",
                "help.files.point4": "Bekijk een voorbeeld voordat u het verzendt.",
                "help.files.point5": "Voortgangsbalk tijdens het laden.",
                "help.files.point6": "Exporteer volledige gesprekken naar:",
                "help.files.point7": "Pdf",
                "help.files.point8": "Html",
                "help.files.point9": "Inclusief berichten, afbeeldingen en bestanden.",
                "help.files.point10": "Uw gegevens zijn van u.",
                "help.experience.title": "🎨 Gebruikerservaring",
                "help.experience.point1": "Aanwezigheidsstatussen en aangepaste statussen met emoji.",
                "help.experience.point2": "Geïntegreerde OpenMoji-emoji's.",
                "help.experience.point3": "Lees- en schrijfindicatoren.",
                "help.experience.point4": "Geoptimaliseerde mobiele weergave gelijk aan desktop.",
                "help.experience.point5": "Installeerbare PWA-applicatie.",
                "help.experience.point6": "Twee thema's: Argentinië (lichtblauw/wit/goud) en Oscuro (dieppaars).",
                "help.experience.point7": "Profiel bewerken zonder frisdrank.",
                "help.experience.point8": "Landkiezer met automatische tijdzone.",
                'help.experience.point9': 'Snelle toegang met favorieten, zoeken en filters.',
                "help.languages.title": "🌍 Talen",
                "help.languages.point1": "Ondersteuning voor {count} talen.",
                "help.languages.point2": "Visuele selector met vlaggen.",
                "help.languages.point3": "Interface, algemene voorwaarden en e-mails aangepast aan de gekozen taal.",
                "help.languages.point4": "Automatische vertaling in twee richtingen tussen gebruikers.",
                "help.tipsNew.title": "💡 Tips om te profiteren van ArChat®",
                "help.tipsNew.point1": "Nodig alleen mensen uit met wie u echt wilt communiceren.",
                "help.tipsNew.point2": "Gebruik aliassen en privénotities om contacten te ordenen.",
                "help.tipsNew.point3": "Markeer favorieten voor snelle toegang.",
                "help.tipsNew.point4": "Controleer de vertaling voordat u belangrijke berichten verzendt.",
                "help.tipsNew.point5": "Exporteer relevante gesprekken voor back-up of werk.",
                "help.tipsNew.point6": "Gebruik ArChat® wanneer schriftelijke duidelijkheid essentieel is.",
                "help.whySubscribe.title": "🚀 Waarom abonneren op ArChat®",
                "help.whySubscribe.point1": "ArChat® is niet ontworpen om met zomaar iemand te chatten,",
                "help.whySubscribe.point2": "maar om beter te communiceren met degenen die er toe doen.",
                "help.whySubscribe.point3": "Als je nodig hebt:",
                "help.whySubscribe.point4": "duidelijkheid tussen talen",
                "help.whySubscribe.point5": "echte privacy",
                "help.whySubscribe.point6": "contactcontrole",
                "help.whySubscribe.point7": "gesprek exporteren",
                "help.whySubscribe.point8": "een professionele en ruisvrije ervaring",
                "help.whySubscribe.point9": "ArChat® is daarvoor ontworpen.",
                "help.how.step1.description": "Gebruik uw bijnaam en wachtwoord om toegang te krijgen. Als u geen account heeft, wordt deze automatisch aangemaakt.",
                "help.how.step2.title": "Nodig uw contactpersoon uit",
                "help.how.step2.description": "Nodig uit per e-mail vanuit uw profiel en definieer de taal en de gesprekswijze.",
                "help.how.step3.title": "Schrijf in uw taal",
                "help.how.step3.description": "Schrijf in de taal van uw voorkeur en ArChat® vertaalt het bericht automatisch.",
                "help.how.step4.title": "De ontvanger ontvangt het vertaald",
                "help.how.step4.description": "De andere persoon ontvangt het bericht met context en duidelijkheid in zijn of haar taal vertaald.",
                "help.features.title": "Belangrijkste kenmerken",
                "help.features.translation": "🌐 Automatische en onmiddellijke vertaling tussen talen",
                "help.features.status": "💬 Aanwezigheidsstatussen (online, inactief, niet storen, enz.)",
                "help.features.statusCustom": "💬 Aangepaste statussen met emoji en persoonlijk bericht",
                "help.features.contacts": "👥 Volledige lijst met contacten met vastgezette favorieten (boven) en blokken die kunnen worden beheerd vanuit de modus Gebruikers",
                "help.features.contactsMobile": "📱 Geoptimaliseerde mobiele weergave met status en weergave in de bovenste balk (hetzelfde als pc)",
                "help.features.contactsFilter": "👁️ Knop niet-favoriete contacten tonen/verbergen - verklein de lijst tot alleen uw favorieten",
                "help.features.contactAlias": "✏️ Aangepaste alias en privénotities voor elk contact - klik op de contactnaam in het gesprek",
                "help.features.themes": "🎨 Twee thema's beschikbaar: Argentinië (lichtblauw/wit/goud) en Oscuro (dieppaars)",
                "help.features.messages": "📨 Realtime berichtenuitwisseling met leesindicatoren, inline OpenMoji-emoji's en zichtbaar typen",
                "help.features.attachments": "📎 Bestanden bijvoegen die compatibel zijn met schriftelijke communicatie: afbeeldingen, video's en PDF-documenten",
                "help.features.camera": "📸 Maak foto's met voorkant, achterkant of webcam",
                "help.features.gallery": "🖼️ Bestandsselectie uit galerij",
                "help.features.compression": "🗜️ Automatische beeldcompressie en het genereren van miniaturen",
                "help.features.progress": "📊 Voortgangsbalk tijdens het uploaden van bestanden",
                "help.features.delete": "🗑️Verwijdering van eigen berichten",
                "help.features.scroll": "⬇️ Automatisch scrollen naar het laatste bericht bij het openen van een gesprek",
                "help.features.profile": "👤 Aanpasbaar profiel met avatar, biografie en voorkeuren",
                "help.features.profileEdit": "✏️ Naadloos profiel bewerken (vernieuwt niet tijdens het bewerken)",
                "help.features.countries": "🌍 Volledige lijst van meer dan 195 landen met automatische tijdzoneselectie",
                "help.features.registration": "📧 Registratie met verplichte Algemene voorwaarden voordat u een account aanmaakt en een e-mailbevestiging",
                "help.features.multilanguage": "🗣️ Ondersteuning voor {count} talen met vlaggen; Algemene voorwaarden en e-mails vertaald in de gekozen taal",
                "help.features.pwa": "📲 PWA-applicatie installeerbaar op mobiele apparaten en desktop",
                "help.features.sync": "🔄 Automatische berichtensynchronisatie elke 5 seconden",
                "help.features.deleteSync": "🗑️ Automatische synchronisatie van verwijderde berichten tussen apparaten",
                "help.features.notifications": "🔔 Geluidsmeldingen voor nieuwe ontvangen berichten",
                "help.features.retranslation": "🔄 Automatische hervertaling van berichten als het de eerste keer mislukt",
                "help.features.preview": "👁️ Bekijk een voorbeeld van bestanden voordat u ze verzendt",
                "help.features.security": "🔒 Beveiligingssysteem met CAPTCHA, vingerafdruk, snelheidsbeperking en verplichte algemene voorwaarden",
                "help.features.passwordRecovery": "🔑 Wachtwoordherstel per e-mail",
                "help.features.emailConfirmation": "📧 Accountbevestiging per e-mail met activatielink",
                "help.features.invitations": "📧 Privé-e-mailuitnodigingen - Nodig externe contacten uit met gedefinieerde taal en context",
                "help.features.invitationsManagement": "📋 Compleet uitnodigingsbeheer - Lijst, verzend of annuleer openstaande uitnodigingen vanuit het menu",
                "help.features.contactStatus": "🏷️ Zichtbare contactstatussen - Bekijk de status van elk contact (in behandeling, geregistreerd, klaar om te chatten)",
                "help.features.favorites": "⭐ Favorietensysteem - Markeer contacten als favorieten voor snelle toegang ertoe",
                "help.features.profilePhoto": "📸 Verbeterde upload van profielfoto's - Selecteer afbeeldingen uit de galerij met onmiddellijke preview",
                "help.features.translationSender": "👁️ Vertalingen voor de afzender bekijken - Bekijk hoe uw bericht is vertaald in de taal van de ontvanger",
                "help.features.unifiedContacts": "🔗 Uniform contactmodel - Contacten zijn afgeleid van bestaande uitnodigingen en gesprekken",
                "help.features.privacy": "🔒 Standaard privémodus - Uw profiel is privé en alleen toegankelijk via directe uitnodiging",
                "help.features.export": "💾 Gesprek exporteren - Exporteer volledige gesprekken naar PDF of HTML met afbeeldingen en bestanden",
                "help.tips.title": "Handige tips",
                "help.tips.language": "✅ Stel uw taal in met de vlagkiezer {count}; Algemene voorwaarden en e-mails worden in die taal weergegeven",
                "help.tips.status": "✅ Update uw aanwezigheidsstatus zodat anderen uw beschikbaarheid kennen",
                "help.tips.statusCustom": "✅ Creëer aangepaste statussen met emoji en bericht om uw huidige status uit te drukken",
                "help.tips.search": "✅ Markeer favorieten (ster) en blokkeer gebruikers in de modaliteit \"Gebruikers\".",
                "help.tips.contactsFilter": "✅ Gebruik de oogknop (👁️) in de bovenste balk om niet-favoriete contacten te tonen of te verbergen",
                "help.tips.contactAlias": "✅ Klik op de contactnaam in het gesprek om een ​​aangepaste alias en privénotities toe te voegen",
                "help.tips.avatar": "✅ Klik op de avatar van een contactpersoon om de afbeelding groter te zien",
                "help.tips.messages": "✅ Het ArChat®-pictogram knippert als u ongelezen berichten heeft; voeg emoji's in met het OpenMoji-opstartprogramma",
                "help.tips.attachments": "✅ Voeg afbeeldingen, video's of pdf's toe met de clipknop (📎); compatibel met schriftelijke communicatie",
                "help.tips.camera": "✅ Gebruik de camera om foto's rechtstreeks vanuit de app te maken",
                "help.tips.compression": "✅ Afbeeldingen worden automatisch gecomprimeerd om ruimte te besparen",
                "help.tips.delete": "✅ Je kunt je eigen berichten verwijderen door op de verwijderknop te klikken",
                "help.tips.profile": "✅ Bewerk je profiel zonder frisdrank en schakel tussen Argentinië / Donker (licht of donker thema).",
                "help.tips.themes": "✅ Wijzig het thema via Instellingen > Uiterlijk: Argentinië (lichtblauw) of Donker (dieppaars)",
                "help.tips.country": "✅ Selecteer uw land in het profiel zodat de tijdzone automatisch wordt ingesteld",
                "help.message_time_context.title": "Tijdelijke context van berichten",
                "help.message_time_context.description": "Bij elk bericht kan de lokale tijd, tijdzone en land van de afzender op het moment van verzending worden opgeslagen. Zo kun je zien waar en hoe laat de andere gebruiker heeft verzonden.",
                "help.message_time_context.point1": "In het GRATIS abonnement wordt alleen de tijd in uw tijdzone (ontvanger) weergegeven.",
                "help.message_time_context.point2": "In het PRO-plan worden ook de lokale tijd, het land en de tijdzone van de uitgevende instelling weergegeven.",
                "help.message_time_context.point3": "In elk bericht wordt de context historisch opgeslagen.",
                "help.message_time_context.point4": "Geavanceerde auditfuncties zijn beschikbaar op hogere abonnementen.",
                "help.tips.registration": "✅ Accepteer voordat u zich registreert de Algemene Voorwaarden in uw taal; verifieer vervolgens uw e-mailadres om het account te activeren",
                "help.tips.writing": "✅ Schrijf duidelijke berichten: ArChat® vertaalt de betekenis van geschreven tekst, waarbij de context en duidelijkheid behouden blijven",
                "help.tips.install": "✅ Installeer ArChat® als PWA-app op uw apparaat voor snelle desktoptoegang",
                "help.tips.sync": "✅ Berichten worden automatisch elke 5 seconden gesynchroniseerd - vernieuwen is niet nodig",
                "help.tips.deleteSync": "✅ Als je een bericht verwijdert, wordt het automatisch verwijderd op alle apparaten van de ontvanger",
                "help.tips.notifications": "✅ Je hoort een geluid wanneer je een nieuw bericht ontvangt van een andere gebruiker",
                "help.tips.retranslation": "✅ Als een bericht niet correct is vertaald, probeert het systeem het automatisch opnieuw te vertalen",
                "help.tips.preview": "✅ Controleer het bestandsvoorbeeld voordat u het verzendt om er zeker van te zijn dat dit het juiste is",
                "help.tips.passwordRecovery": "✅ Bent u uw wachtwoord vergeten, gebruik dan de link \"Wachtwoord vergeten?\" in de login",
                "help.tips.emailConfirmation": "✅ Controleer je e-mail na registratie en klik op de bevestigingslink",
                "help.tips.languageChange": "✅ Wijzig uw taal via de vlagkiezer: algemene voorwaarden, e-mails en gebruikersinterface worden onmiddellijk bijgewerkt",
                "help.tips.inputFixed": "✅ Op pc is de schrijfbalk onderaan het scherm bevestigd voor meer comfort",
                "help.tips.invitations": "✅ Nodig contacten per e-mail uit vanuit uw profiel - Definieer vanaf het begin de taal en gespreksmodus",
                "help.tips.invitationsManagement": "✅ Beheer uw uitnodigingen via het menu \"Verzonden uitnodigingen\" - Verstuur e-mails opnieuw of annuleer openstaande uitnodigingen",
                "help.tips.contactStatus": "✅ Bekijk de status van elk contact in de lijst: In behandeling (oranje), Geregistreerd (groen) of Actief gesprek (blauw)",
                "help.tips.favorites": "✅ Markeer contacten als favorieten met de ster ⭐ - Favorieten verschijnen als eerste in je lijst",
                "help.tips.profilePhoto": "✅ Upload uw profielfoto vanuit \"Kies uit galerij\" - U ziet een voorbeeld voordat u opslaat",
                "help.tips.translationSender": "✅ Vouw bij het verzenden van een bericht het vertaalpaneel uit om te zien hoe het is vertaald in de taal van de ontvanger",
                "help.tips.unifiedContacts": "✅ Je contacten worden automatisch getoond wanneer ze uitnodigingen accepteren of gesprekken met ze voeren",
                "help.tips.privacy": "✅ Je profiel is standaard privé - Activeer de publieke zichtbaarheid in Profiel > Privacy als je wilt dat anderen je kunnen vinden",
                "help.tips.export": "✅ Exporteer hele gesprekken met de ⬇️ knop in de koptekst - Kies PDF of HTML met alle afbeeldingen",
                "help.support.title": "Medium",
                "help.support.description": "Als u problemen of vragen heeft, neem dan contact op met uw systeembeheerder of bekijk de beschikbare technische documentatie.",
                'presence.title': 'Aanwezigheidsstatus',
                'presence.currentStatus': 'Huidige status:',
                'presence.changeStatus': 'Status wijzigen',
                "presence.status.online": "Online",
                'presence.status.online.title': 'Online - Zichtbaar voor iedereen',
                'presence.status.online.description': 'Online: Zichtbaar voor alle contacten',
                'presence.status.idle': 'Inactief',
                'presence.status.idle.title': 'Inactief - Geeft tijdelijke afwezigheid aan',
                'presence.status.idle.description': 'Inactief: Geeft aan dat u tijdelijk niet beschikbaar bent',
                'presence.status.dnd': 'Niet storen',
                'presence.status.dnd.title': 'Niet storen - Geeft aan dat u liever niet gestoord wordt',
                'presence.status.dnd.description': 'Niet storen: Zichtbaar signaal dat u liever niet gestoord wordt',
                'presence.status.busy': 'Bezet',
                'presence.status.busy.title': 'Bezet - Niet beschikbaar',
                'presence.status.busy.description': 'Bezet: Niet beschikbaar',
                "presence.status.offline": "Offline",
                'presence.status.offline.title': 'Verbonden uit - Verschijn offline',
                'presence.status.offline.description': 'Offline: Verschijn als niet verbonden',
                'presence.status.custom': 'Aangepast',
                'presence.status.custom.title': 'Aangepast - Unieke status met emoji',
                'presence.status.custom.description': 'Aangepast: Unieke status met emoji en optionele vervaldatum',
                'presence.custom.title': 'Aangepaste status',
                'presence.custom.status': 'Aangepaste status',
                'presence.custom.placeholder': 'Bijv.: Koffie drinken ☕',
                'presence.custom.emoji': 'Emoji (optioneel)',
                'presence.custom.emojiHelp': 'Selecteer een emoji of typ er een',
                'presence.custom.temporary': 'Tijdelijke status (vervalt automatisch)',
                'presence.custom.expiration': 'Vervaldatum',
                'presence.custom.expirationHelp': 'Status keert terug naar "Online" wanneer deze verloopt',
                'presence.custom.suggestions': 'Suggesties',
                'presence.custom.preview': 'Voorbeeld',
                'presence.custom.save': 'Status opslaan',
                'presence.custom.required': 'Aangepaste status is verplicht',
                'presence.custom.maxLength': 'Maximaal 64 tekens',
                'presence.custom.expirationRequired': 'Je moet een vervaldatum selecteren',
                'presence.custom.expirationFuture': 'Vervaldatum moet in de toekomst liggen',
                'presence.custom.selectEmoji': 'Emoji selecteren',
                "export.title": "Gesprek exporteren",
                "export.description": "Selecteer het formaat waarin u dit gesprek wilt exporteren:",
                "export.progress": "Exporteren...",
                "export.format.pdf": "Pdf",
                "export.format.pdf.description": "PDF-document met alle afbeeldingen en bestanden",
                "export.format.html": "Html",
                "export.format.html.description": "HTML-bestand dat u in elke browser kunt openen",
                "export.info": "De export bevat alle berichten, afbeeldingen en bestanden uit dit gesprek.",
                "export.pro_required.title": "Gesprek exporteren",
                "export.pro_required.message": "Deze functie is beschikbaar in het PRO-abonnement.",
                'invitation.title': 'Nodig contact uit via e-mail',
                'invitation.modal.title': 'Uitnodiging verzenden',
                'invitation.modal.description': 'Nodig iemand uit om met je te chatten op ArChat®. Deze persoon ontvangt een e-mail met een link om de uitnodiging te accepteren.',
                'invitation.email.label': 'E-mail van genodigde',
                "invitation.email.placeholder": "ejemplo@email.com",
                'invitation.email.required': 'E-mail is verplicht',
                'invitation.email.invalid': 'Voer een geldig e-mailadres in',
                'invitation.language.label': 'Voorkeurstaal van de genodigde',
                'invitation.language.help': 'De e-mail wordt in deze taal verzonden',
                'invitation.mode.label': 'Gespreksmodus',
                'invitation.mode.profesional': 'Professioneel',
                'invitation.mode.profesional.description': 'Formeel en professioneel gesprek',
                'invitation.mode.tecnico': 'Technisch',
                'invitation.mode.tecnico.description': 'Technisch en gespecialiseerd gesprek',
                "invitation.mode.casual": "Casual",
                'invitation.mode.casual.description': 'Informeel en vriendelijk gesprek',
                'invitation.message.label': 'Persoonlijk bericht (optioneel)',
                'invitation.message.placeholder': 'Schrijf een persoonlijk bericht voor de genodigde...',
                'invitation.send': 'Uitnodiging verzenden',
                'invitation.sending': 'Bezig met verzenden...',
                'invitation.success': 'Uitnodiging succesvol verzonden',
                'invitation.success.title': 'Uitnodiging verzonden',
                'invitation.success.message': 'Uitnodiging succesvol verzonden.\n\nDe contactpersoon ontvangt een e-mail met een link om de uitnodiging te accepteren. Na acceptatie kun je beginnen met chatten.',
                'invitation.error': 'Fout bij het verzenden van uitnodiging',
                'invitation.error.self': 'Je kunt jezelf niet uitnodigen',
                'invitation.error.duplicate': 'Er bestaat al een wachtende uitnodiging voor dit e-mailadres',
                'invitation.list.title': 'Verzonden uitnodigingen',
                'invitation.list.empty': 'Je hebt nog geen uitnodigingen verzonden',
                "invitation.list.email": "E-mail",
                'invitation.list.language': 'Taal',
                'invitation.list.mode': 'Modus',
                "invitation.list.status": "Staat",
                'invitation.list.created': 'Verzonden',
                'invitation.list.expires': 'Verloopt',
                'invitation.list.actions': 'Acties',
                'invitation.status.pending': 'In behandeling',
                'invitation.status.accepted': 'Geaccepteerd',
                'invitation.status.expired': 'Verlopen',
                'invitation.status.cancelled': 'Geannuleerd',
                'invitation.copy.link': 'Link kopiëren',
                'invitation.copy.success': 'Link gekopieerd naar klembord',
                'invitation.cancel': 'Annuleren',
                'invitation.cancel.confirm': 'Weet je zeker dat je deze uitnodiging wilt annuleren?',
                'invitation.cancel.success': 'Uitnodiging succesvol geannuleerd',
                'invitation.cancel.title': 'Annulering bevestigen',
                'invitation.resend': 'E-mail opnieuw verzenden',
                'invitation.resend.title': 'Uitnodiging opnieuw verzenden',
                'invitation.resend.success': 'Uitnodigingsmail succesvol opnieuw verzonden',
                'invitation.resend.error': 'Fout bij opnieuw verzenden van uitnodigingsmail',
                'invitation.accept.title': 'Uitnodiging accepteren',
                'invitation.accept.description': 'Je bent uitgenodigd om te chatten op ArChat®',
                'invitation.accept.inviter': 'Uitgenodigd door',
                'invitation.accept.message': 'Persoonlijk bericht',
                'invitation.accept.login': 'Inloggen',
                'invitation.accept.register': 'Registreren',
                'invitation.accept.error.invalid': 'Ongeldig uitnodigingstoken',
                'invitation.accept.error.expired': 'Deze uitnodiging is verlopen',
                'invitation.accept.error.accepted': 'Deze uitnodiging is al geaccepteerd',
                'invitation.accept.error.cancelled': 'Deze uitnodiging is geannuleerd',
                'invitation.accept.error.email_mismatch': 'Je account-e-mailadres komt niet overeen met het uitnodigingsadres',
                'invitation.accept.success': 'Uitnodiging geaccepteerd. Doorsturen naar chat...',
                'invitations.sent.title': 'Verzonden uitnodigingen',
                'invitations.sent.empty': 'Geen openstaande uitnodigingen',
                'invitations.pending.title': 'Openstaande uitnodigingen',
                'invitations.columns.email': 'E-mail',
                'invitations.columns.language': 'Taal',
                'invitations.columns.mode': 'Modus',
                "invitations.columns.status": "Staat",
                'invitations.columns.sentAt': 'Verzonden',
                'invitations.columns.actions': 'Acties',
                'invitations.status.pending': 'In behandeling',
                'invitations.status.accepted': 'Geaccepteerd',
                'invitations.status.cancelled': 'Geannuleerd',
                'invitations.status.expired': 'Verlopen',
                'invitations.actions.cancel': 'Annuleren',
                'invitations.actions.copy': 'Link kopiëren',
                'invitations.actions.resend': 'E-mail opnieuw verzenden',
                "profile.privacy.title": "Privacy",
                "profile.privacy.public_visibility": "Maak mijn profiel openbaar zichtbaar",
                "profile.privacy.public_warning": "Hierdoor kan elke ArChat®-gebruiker u vinden en een gesprek beginnen.",
                "profile.privacy.private_info": "Je profiel is privé. Alleen gebruikers die u uitnodigt of die u uitnodigen, kunnen met u chatten.",
                "profile.privacy.private_default": "Standaard is uw profiel privé voor meer veiligheid.",
                'common.close': 'Sluiten',
                'common.cancel': 'Annuleren',
                "common.save": "Houden",
                "common.saving": "Besparing...",
                'buttons.accept': 'Accepteren',
                "buttons.cancel": "Annuleren",
                "buttons.save": "Houden",
                "buttons.edit": "Bewerking",
                "buttons.retry": "Opnieuw proberen",
                "buttons.confirm": "Bevestigen",
                "buttons.yes": "Ja",
                "buttons.no": "Nee",
                "buttons.send": "Versturen",
                "buttons.close": "Dichtbij",
                "buttons.continue": "Doorgaan",
                "buttons.delete": "Elimineren",
                "buttons.logout": "Ga naar buiten",
                "buttons.back": "Opbrengst",
                "buttons.update": "Update",
                "buttons.upload": "Toename",
                "buttons.select": "Selecteer",
                "contact.edit.info.personalized": "Deze wijzigingen zijn speciaal voor u gepersonaliseerd en hebben geen invloed op andere gebruikers.",
                "contact.edit.profileInfo": "Profielinformatie",
                "dashboard.title": "Dashboard",
                'dashboard.planUsage': 'Plangebruik',
                'dashboard.filesSummary': 'Mijn bestanden',
                'dashboard.promotions': 'Acties',
                'dashboard.sessions': 'Actieve sessies',
                'dashboard.explore': 'Verkennen',
                'dashboard.noSessions': 'Geen actieve sessies',
                'dashboard.welcomeTitle': 'Welkom bij ArChat®',
                'dashboard.welcomeSubtitle': 'Communiceer in elke taal.',
                'dashboard.stepInvite': 'Stap 1: nodig je eerste contact uit',
                'dashboard.stepMessage': 'Stap 2: stuur je eerste bericht',
                'dashboard.inviteContact': 'Contact uitnodigen',
                'dashboard.exploreArChat': 'ArChat verkennen',
                'dashboard.promotionsTitle': 'Promoties',
                'dashboard.promotionsText': 'Overzicht van het verwijzings- en beloningsprogramma.',
                'dashboard.viewPromotions': 'Promoties bekijken',
                'dashboard.usageTitle': 'Plangebruik',
                'dashboard.sessionsTitle': 'Actieve sessies',
                'dashboard.sessionsEmpty': 'Geen actieve sessies',
                'dashboard.filesTitle': 'Mijn bestanden',
                'dashboard.viewFiles': 'Mijn bestanden tonen',
                'dashboard.noBlocks': 'Geen actieve blokken. Schakel minstens één in bij Instellingen.',
                'dashboard.openSettings': 'Instellingen openen',
                'dashboard.goToContacts': 'Naar contacten',
                'dashboard.recentInbound.title': 'Laatste ontvangen berichten',
                'dashboard.recentInbound.empty': 'Geen recente ontvangen berichten.',
                'dashboard.recentInbound.error': 'Berichten konden niet worden geladen.',
                "dashboard.recentInbound.previewPhoto": "Foto",
                'dashboard.recentInbound.previewFile': 'Bestand',
                "dashboard.recentInbound.previewPdf": "Pdf",
                'dashboard.recentInbound.previewUnavailable': 'Bericht niet beschikbaar',
                'dashboard.recentInbound.readTitle': 'Gelezen',
                'dashboard.recentInbound.unreadTitle': 'Ongelezen',
                'dashboard.recentConversations.title': 'Recente gesprekken',
                'dashboard.recentConversations.empty': 'Geen gesprekken om te tonen.',
                'dashboard.recentConversations.error': 'Gesprekken konden niet worden geladen.',
                'dashboard.filesVisible': 'Zichtbare bestanden',
                'dashboard.filesSampleNote': 'Aantal op de eerste pagina (max. 500+).',
                "dashboard.loading": "Gegevens laden...",
                "dashboard.error.title": "Fout",
                "dashboard.error.load": "Gebruiksgegevens konden niet worden geladen",
                "dashboard.error.generic": "Fout bij laden van dashboard",
                "dashboard.error.no_data": "Gegevens konden niet worden geladen",
                "dashboard.retry": "Opnieuw proberen",
                "dashboard.unlimited": "Onbeperkt",
                'dashboard.not_available': 'Niet beschikbaar',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                "dashboard.card.contacts": "Contacten",
                'dashboard.card.chars': 'Tekens',
                "dashboard.card.chars_month": "Personages deze maand",
                "dashboard.card.storage": "Opslag",
                "dashboard.card.devices": "Actieve apparaten",
                "dashboard.upgrade.title": "Heeft u meer middelen nodig?",
                'dashboard.upgrade.message': 'Upgrade your plan to get more contacts, characters, storage and active devices.',
                "dashboard.upgrade.button": "Verbeterplan",
                "upgrade.title": "Verbeterplan",
                "upgrade.close": "Dichtbij",
                "upgrade.cancel": "Annuleren",
                "upgrade.activate": "Activeer PRO-abonnement",
                "upgrade.activating": "Activeren...",
                "upgrade.comparison.title": "Planvergelijking",
                "upgrade.free.label": "Gratis abonnement",
                "upgrade.free.limits.contacts": "Maximaal 2 contacten",
                "upgrade.free.limits.conversations": "Maximaal 2 gesprekken",
                "upgrade.free.limits.no_export": "Geen gegevensexport",
                "upgrade.free.limits.no_advanced": "Geen geavanceerde functies",
                "upgrade.pro.label": "Pro-plan",
                "upgrade.pro.recommended": "AANBEVOLEN",
                'upgrade.pro.benefits.contacts': 'Unlimited contacts',
                'upgrade.pro.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
                'upgrade.pro.benefits.conversations': 'Unlimited conversations',
                'upgrade.pro.benefits.conversations.desc': 'Keep all active conversations you need',
                "upgrade.pro.benefits.export": "Gesprek exporteren",
                "upgrade.pro.benefits.export.desc": "Exporteer uw gesprekken in meerdere formaten (PDF, TXT, JSON)",
                "upgrade.pro.benefits.notifications": "Geavanceerde meldingen",
                "upgrade.pro.benefits.notifications.desc": "Aangepaste meldingen en geavanceerde instellingen",
                'upgrade.pro.benefits.translation': 'Unlimited automatic translation',
                'upgrade.pro.benefits.translation.desc': 'Translate messages without usage limits',
                'upgrade.pro.benefits.files': 'Unlimited file sharing',
                'upgrade.pro.benefits.files.desc': 'Share files of any size without restrictions',
                "upgrade.pro.benefits.themes": "Aangepaste thema's",
                "upgrade.pro.benefits.themes.desc": "Toegang tot alle thema's en geavanceerd maatwerk",
                "upgrade.pro.benefits.security": "Geavanceerde beveiliging",
                "upgrade.pro.benefits.security.desc": "Extra bescherming en verbeterde privacyfuncties",
                "upgrade.pro.benefits.analytics": "Statistieken en analyse",
                "upgrade.pro.benefits.analytics.desc": "Krijg toegang tot gedetailleerde statistieken van uw activiteit",
                "upgrade.pro.benefits.priority": "Prioritaire ondersteuning",
                "upgrade.pro.benefits.priority.desc": "Prioritaire aandacht en snelle reactie op uw vragen",
                "upgrade.enterprise.label": "Enterprise-plan",
                "upgrade.enterprise.benefits.contacts": "Onbeperkte contacten",
                "upgrade.enterprise.benefits.support": "24/7 prioriteitsondersteuning",
                "upgrade.enterprise.benefits.custom": "Maatwerk oplossingen",
                "upgrade.enterprise.benefits.advanced": "Geavanceerde zakelijke functies",
                "upgrade.enterprise.benefits.integration": "Aangepaste integraties",
                "upgrade.enterprise.benefits.dedicated": "Toegewijde ondersteuning",
                "upgrade.success.title": "PRO-abonnement geactiveerd",
                "upgrade.success.message": "Je abonnement is geüpgraded naar PRO. Geniet van alle onbeperkte functies.",
                "upgrade.error.title": "Fout bij het activeren van PRO",
                "upgrade.error.message": "Het plan kon niet worden bijgewerkt. Probeer het opnieuw.",
                "upgrade.error.generic": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
                'upgrade.benefits.contacts': 'Unlimited contacts',
                'upgrade.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
                'upgrade.benefits.conversations': 'Unlimited conversations',
                'upgrade.benefits.conversations.desc': 'Keep all active conversations you need',
                "upgrade.benefits.export": "Gesprek exporteren",
                "upgrade.benefits.export.desc": "Exporteer uw gesprekken in meerdere formaten (PDF, TXT, JSON)",
                "upgrade.benefits.notifications": "Geavanceerde meldingen",
                "upgrade.benefits.notifications.desc": "Aangepaste meldingen en geavanceerde instellingen",
                'upgrade.benefits.translation': 'Unlimited automatic translation',
                'upgrade.benefits.translation.desc': 'Translate messages without usage limits',
                'upgrade.benefits.files': 'Unlimited file sharing',
                'upgrade.benefits.files.desc': 'Share files of any size without restrictions',
                "upgrade.benefits.themes": "Aangepaste thema's",
                "upgrade.benefits.themes.desc": "Toegang tot alle thema's en geavanceerd maatwerk",
                "upgrade.benefits.security": "Geavanceerde beveiliging",
                "upgrade.benefits.security.desc": "Extra bescherming en verbeterde privacyfuncties",
                "upgrade.benefits.analytics": "Statistieken en analyse",
                "upgrade.benefits.analytics.desc": "Krijg toegang tot gedetailleerde statistieken van uw activiteit",
                "upgrade.benefits.priority": "Prioritaire ondersteuning",
                "upgrade.benefits.priority.desc": "Prioritaire aandacht en snelle reactie op uw vragen",
                "upgrade.limits.contacts": "Maximaal 2 contacten",
                "upgrade.limits.conversations": "Maximaal 2 gesprekken",
                "upgrade.limits.no_export": "Geen gegevensexport",
                "upgrade.limits.no_advanced": "Geen geavanceerde functies",
                // API Error Messages
                "api.error.image_processing_not_available": "Beeldverwerking is niet beschikbaar op de server",
                "api.error.image_functions_not_available": "Beeldverwerkingsfuncties niet beschikbaar",
                "api.error.method_not_allowed": "Niet-toegestane methode",
                "api.error.user_not_identified": "Onbekende gebruiker",
                "api.error.upload_file_too_large_php": "Het bestand overschrijdt de maximale grootte die door PHP is toegestaan",
                "api.error.upload_file_too_large_form": "Het bestand overschrijdt de maximale grootte die door het formulier is toegestaan",
                "api.error.upload_file_partial": "Het bestand is gedeeltelijk geüpload",
                "api.error.upload_no_file": "Geen bestand geüpload",
                "api.error.upload_no_temp_dir": "Tijdelijke map ontbreekt",
                "api.error.upload_cant_write": "Fout bij het schrijven van bestand naar schijf",
                "api.error.upload_extension_stopped": "Een PHP-extensie is gestopt met uploaden",
                "api.error.upload_generic": "Fout bij het uploaden van bestanden",
                "api.error.file_type_not_allowed": "Bestandstype niet toegestaan. Alleen afbeeldingen (JPEG, PNG, GIF, WEBP) zijn toegestaan",
                "api.error.file_too_large": "Het bestand is te groot (max. 10 MB)",
                "api.error.storage_limit_exceeded": "Opslaglimiet overschreden. Upgrade uw abonnement om meer bestanden te uploaden.",
                "api.error.user_not_found": "Gebruiker niet gevonden of inactief",
                "api.error.image_directory_access": "Fout bij toegang tot de afbeeldingenmap",
                "api.error.file_extension_not_allowed": "Bestandsextensie niet toegestaan",
                "api.error.temp_file_save": "Fout bij opslaan tijdelijk bestand",
                "api.error.image_processing": "Fout bij het verwerken van afbeelding",
                "api.error.database_update": "Fout bij updaten database",
                "api.error.internal_server_error": "Interne serverfout",
                "api.error.internal_server_error_debug": "Interne serverfout",
                "api.error.user_id_required": "Vereiste gebruikers-ID",
                "api.error.profile_not_found": "Profiel niet gevonden",
                "api.error.profile_load_failed": "Fout bij laden van profiel",
                "api.error.invalid_data": "Ongeldige gegevens",
                "api.error.validation_errors": "Validatiefouten",
                "api.error.profile_update_failed": "Kan profiel niet updaten",
                "api.error.profile_update_error": "Fout bij updaten van profiel",
                // API Success Messages
                "api.success.photo_updated": "Bijgewerkte foto",
                "api.success.profile_loaded": "Profiel succesvol geladen",
                "api.success.profile_updated": "Profiel is succesvol bijgewerkt",
                // Error Messages - Device Limits
                "errors.deviceLimit.title": "Apparaatlimiet bereikt",
                "errors.deviceLimit.solution": "Meld u af bij andere apparaten of upgrade uw abonnement om door te gaan.",
                // Error Messages - Network
                "errors.network.title": "Verbindingsfout",
                "errors.network.message": "Kan geen verbinding maken met de server. Controleer uw internetverbinding.",
                // Error Messages - Server
                "errors.server.invalidResponse.title": "Serverfout",
                "errors.server.invalidResponse.message": "De server heeft een ongeldig antwoord geretourneerd. Probeer het opnieuw.",
                // Error Messages - Generic
                "errors.generic.title": "Fout",
                "errors.generic.message": "Er is een fout opgetreden. Probeer het opnieuw.",
                "errors.generic.403.title": "Toegangsfout",
                "errors.generic.403.message": "U heeft geen toestemming om deze actie uit te voeren.",
                'errors.saas_max_users': 'Plan gebruikerslimiet bereikt ({current}/{limit}).',
                'errors.tenant_frozen': 'De tenant is tijdelijk geblokkeerd.',
                "errors.auth_invalid_credentials": "Onjuiste gebruikersnaam of wachtwoord.",
                "errors.unexpected_error": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
                "errors.accountInactive.title": "Het account is inactief. Vul uw e-mail in om deze opnieuw te activeren.",
                "errors.userInactive.title": "Gedeactiveerd account",
                "errors.tenantMismatch.title": "Fout van huurder",
                "errors.accountInactive.activate": "Activeer nu",
                "errors.accountInactive.accept": "Accepteren",
                "errors.accountInactive.success": "Account opnieuw geactiveerd. U kunt nu inloggen.",
                "errors.accountInactive.fail": "Kan account niet opnieuw activeren. Probeer het opnieuw.",
                "errors.accountInactive.completeSuccess": "Account geactiveerd met uw e-mailadres. U kunt nu inloggen.",
                "errors.accountInactive.completeFail": "De activering kon niet worden voltooid. Controleer de e-mail en probeer het opnieuw.",
                // Plan Errors - Device Limit
                "plan.errors.deviceLimit.title": "Planlimiet bereikt",
                "plan.errors.deviceLimit.message": "Uw huidige abonnement heeft een limiet op het aantal gelijktijdig verbonden apparaten.",
                "plan.errors.deviceLimit.solution": "Meld u af bij andere apparaten of upgrade uw abonnement naar PRO om door te gaan.",
                // Plan Errors - Contacts Limit
                "plan.errors.contactsLimit.title": "Contactlimiet bereikt",
                "plan.errors.contactsLimit.message": "Uw huidige abonnement heeft een limiet op het aantal contacten dat u kunt hebben.",
                "plan.errors.contactsLimit.solution": "Upgrade uw abonnement naar PRO om meer contacten toe te voegen.",
                // Plan Errors - Invitations Limit
                "plan.errors.invitationsLimit.title": "Uitnodigingslimiet bereikt",
                "plan.errors.invitationsLimit.message": "Uw huidige abonnement heeft een limiet op het aantal uitnodigingen dat u per dag kunt verzenden.",
                "plan.errors.invitationsLimit.solution": "Upgrade uw abonnement naar PRO om meer uitnodigingen te verzenden.",
                // Plan Errors - Messages Limit
                "plan.errors.messagesLimit.title": "Berichtlimiet bereikt",
                "plan.errors.messagesLimit.message": "Uw huidige abonnement heeft een limiet op het aantal berichten dat u per dag kunt verzenden.",
                "plan.errors.messagesLimit.solution": "Upgrade uw abonnement naar PRO om meer berichten te verzenden.",
                // Plan Errors - Storage Limit
                "plan.errors.storageLimit.title": "Opslaglimiet bereikt",
                "plan.errors.storageLimit.message": "Uw huidige abonnement heeft een limiet op de hoeveelheid beschikbare opslagruimte.",
                "plan.errors.storageLimit.solution": "Upgrade naar PRO voor meer opslagruimte.",
                // Plan Errors - Upgrade Required
                "plan.errors.upgradeRequired.title": "Planupgrade vereist",
                "plan.errors.upgradeRequired.message": "Voor deze functie is een hoger abonnement vereist dan het abonnement dat je momenteel hebt.",
                "plan.errors.upgradeRequired.solution": "Upgrade uw abonnement naar PRO om toegang te krijgen tot deze functie.",
                "appearance.theme.system": "Systeem",
                "appearance.theme.corporate": "Zakelijk",
                "theme.system": "Systeem",
                "theme.corporate": "Zakelijk",
                "founder.title": "STICHTING (oprichter)",
                'founder.subtitle': 'Je ondersteunt het project vanaf het begin met een levenslange prijs.',
                'founder.whatIs': 'De eerste 150 gebruikers krijgen het FOUNDATION-plan tegen gereduceerde levenslange prijs.',
                'founder.howItWorks': 'Je Founder-niveau hangt af van je positie (1 tot 150).',
                'founder.benefitsTitle': 'Voordelen',
                'founder.benefitPrice': '$15 / maand (Founder-tarief)',
                'founder.benefitFeatures': 'Inclusief alle PRO-planfuncties.',
                'founder.limit': 'Er bestaan slechts 150 Founder-plaatsen.',
                'founder.cancelRule': 'Bij opzegging verlies je de Founder-status zolang je uitgeschreven bent.',
                'founder.rejoinRule': 'Als er weer plek is, kun je opnieuw activeren en automatisch weer Founder worden.',
                'founder.tiers.title': 'Founder-niveaus',
                "founder.tiers.legendary.name": "LEGENDARISCHE oprichter",
                'founder.tiers.legendary.range': 'Positie 1–25',
                'founder.tiers.legendary.desc': 'De eersten die het project steunden. Hoogste historische prioriteit.',
                "founder.tiers.early.name": "VROEGE oprichter",
                'founder.tiers.early.range': 'Positie 26–75',
                'founder.tiers.early.desc': 'Vroege ondersteuning met speciale erkenning.',
                "founder.tiers.founder.name": "oprichter",
                'founder.tiers.founder.range': 'Positie 76–150',
                'founder.tiers.founder.desc': 'Founder-plaats binnen de 150.',
                'founder.whatIsLink': 'Wat is Founder?',
                'founder.viewTiers': 'Founder-niveaus bekijken',
                'founder.modalClose': 'Sluiten',
                'founder.activeCountLabel': 'Actieve Founders',
                'founder.urgency.lastSlots': 'Laatste Founder-plaatsen beschikbaar',
                "founder.positionLabel": "Oprichter #{position} / {limit}",
                "founder.leaderboard.title": "Topoprichters",
                'login.email.placeholder': 'Voer je e-mail in om je account te bevestigen',
                'login.email.help': 'Er wordt een bevestigingslink naar je e-mail verstuurd',
                'auth.tenant_mismatch': 'Je account hoort niet bij deze omgeving. Neem contact op met de beheerder.',
                'auth.captcha_required': 'Voltooi de beveiligingsverificatie (CAPTCHA).',
                'auth.resend_activation': 'Activeeringsmail opnieuw versturen',
                'register.creatingAccount': 'Je account wordt aangemaakt…',
                'common.edit': 'Bewerken',
                'common.on': 'Aan',
                'common.off': 'Uit',
                'common.refresh': 'Vernieuwen',
                'system.processing': 'Bezig met verwerken...',
                'security.verification_title': 'Beveiligingscontrole',
                'security.captcha_question': 'Verificatievraag',
                'security.enter_answer': 'Voer het antwoord in',
                'captcha.incorrect': 'Het CAPTCHA-antwoord is onjuist.',
                'captcha.placeholder': 'Voer het antwoord in',
                'captcha.questionFormat': 'Hoeveel is {a} + {b}?',
                "navbar.contacts": "Contacten",
                "navbar.profile": "Mijn profiel",
                "navbar.settings": "Configuratie",
                "navbar.logout": "Ga naar buiten",
                "navbar.status": "Staat",
                "navbar.users": "Gebruikers",
                'navbar.no_blocked_users': 'Geen geblokkeerde gebruikers',
                'navbar.blocked_users_title': 'Geblokkeerde gebruikers',
                'contacts.blocked_users_title': 'Geblokkeerde gebruikers',
                'contacts.country_label': 'Land',
                'contacts.not_reported': 'Niet opgegeven',
                "navbar.user_fallback": "Gebruiker {id}",
                "navbar.open_guide": "Gids",
                "help.how_archat_works": "Hoe ArChat® werkt",
                "help.registration": "Dossier",
                'help.private_invitations': 'Privé-uitnodigingen',
                "help.messaging": "Berichten",
                "help.security": "Beveiliging",
                'contacts.no_contacts': 'Geen contacten',
                "invitation.quick_button": "Contactpersoon uitnodigen",
                "onboarding.title": "Welkom bij ArChat®",
                "onboarding.subtitle": "Communiceer met iedereen in welke taal dan ook.",
                "onboarding.step1.label": "Stap 1",
                "onboarding.step1.text": "Nodig je eerste contact uit",
                "onboarding.step2.label": "Stap 2",
                "onboarding.step2.text": "Verstuur uw eerste bericht",
                "onboarding.actions.invite": "Contactpersoon uitnodigen",
                "onboarding.actions.explore": "Ontdek ArChat®",
                'suggestions.captcha_placeholder': 'Resultaat',
                'suggestions.cooldown': 'Je moet {minutes} minuten wachten voordat je een nieuwe suggestie kunt sturen.',
                'suggestions.success_title': 'Suggestie verzonden',
                'suggestions.success_message': 'Je suggestie is succesvol verzonden. Volgnummer: {id}',
                'suggestions.sendSuccess': 'Je suggestie is succesvol verzonden.',
                'suggestions.sendError': 'De suggestie kon niet worden verzonden. Probeer het opnieuw.',
                'suggestions.sent': 'Suggestie succesvol verzonden.',
                'errors.suggestionSend': 'De suggestie kon niet worden verzonden. Probeer het opnieuw.',
                "common.sending": "Verzenden...",
                'app.install': 'ArChat installeren',
                "menu.open": "Menu",
                "contacts.controls.hide_non_favorites": "Verberg niet-favoriete contacten",
                "contacts.controls.show_all": "Toon alle contacten",
                "common.navigation": "Navigatie",
                "common.favorite": "Favoriet",
                "common.block": "Blok",
                "common.user": "Gebruiker",
                "message.new": "nieuw bericht",
                "message.edit": "Bericht bewerken",
                "message.edit.save": "Bewerking opslaan",
                "message.edit.cancel": "Bewerking annuleren",
                'message.translating': 'Bezig met vertalen...',
                'message.translation_failed': 'Vertalen mislukt',
                'message.not_translated': 'Originele tekst',
                'message.retry_send': 'Opnieuw proberen',
                'message.retrying': 'Opnieuw proberen...',
                "message.delete": "Bericht verwijderen",
                'message.deleted_placeholder': 'Bericht verwijderd',
                "message.edited": "Bewerkt",
                "message.edited_at": "Bewerkt op",
                'message.delete_for_me.tooltip': 'Verwijderen voor mij',
                'message.delete_for_me.aria': 'Verwijder dit bericht alleen voor mij',
                'message.delete_for_me.confirm_title': 'Bericht verwijderen',
                'message.delete_for_me.confirm_message': 'Dit bericht wordt alleen uit jouw weergave verwijderd.',
                'message.delete_for_everyone.tooltip': 'Verwijderen voor iedereen',
                'message.delete_for_everyone.aria': 'Verwijder dit bericht voor alle deelnemers',
                'message.delete_for_everyone.confirm_title': 'Bericht voor iedereen verwijderen',
                'message.delete_for_everyone.confirm_message': 'Dit bericht wordt voor jou en de andere deelnemer verwijderd.',
                'message.delete_for_everyone.window_expired': 'Verwijdervenster verlopen',
                "message.translation.show": "Zie origineel en vertaling",
                "message.translation.hide": "Verberg vertaling",
                "emoji.search": "Zoek emoji",
                "emoji.close": "Selectie sluiten",
                "captcha.refresh": "CAPTCHA opnieuw genereren",
                'presence.unavailable': 'Statussen zijn niet beschikbaar',
                'presence.maintenance': 'Server in onderhoud',
                "home.access_nav": "Toegang tot de applicatie",
                "common.requiredFields": "Vul alle verplichte velden in.",
                "bio.view": "Zie biografie",
                'profile.invitations.title': 'Uitnodigingen',
                'profile.invitations.validated': 'Geverifieerde uitnodigingen',
                "profile.invitations.nextBadge": "Volgende prestatie",
                "profile.invitations.progress": "Voortgang",
                "profile.invitations.achievement": "Prestatie",
                "profile.invitations.topInviterAchieved": "Maximale uitnodiger bereikt",
                "profile.invitations.badges.networkBuilder": "Netwerk Bouwer",
                "profile.invitations.badges.topInviter": "Maximale uitnodiger",
                "profile.invitations.achievement.networkBuilderMessage": "Je hebt 20 gebruikers uitgenodigd op ArChat.",
                "profile.invitations.achievement.topInviterMessage": "Je hebt 50 gebruikers uitgenodigd op ArChat.",
                "profile.plan.expires": "verloopt",
                'profile.plan.loading_info': 'Planinformatie laden...',
                "profile.plan.valid_until": "Geldig tot:",
                "profile.plan.active_since": "Actief sinds:",
                "profile.plan.active_badge": "✓ Actief",
                "profile.manage_plan": "Plan beheren",
                "plan.current_plan": "Huidig ​​abonnement",
                "plan.current": "Actual",
                "plan.footer_prefix": "Plan:",
                "plan.upgrade_to_pro": "Upgrade naar PRO",
                "plan.upgrade_to_foundation": "Upgrade naar STICHTING",
                "plan.payment_coming": "Betalen met Paddle is binnenkort beschikbaar. U kunt vanaf hier uw plannen wijzigen.",
                "plan.payment_coming_title": "Spoedig",
                "plan.foundation_full": "Het FOUNDATION-quotum is vol (150 oprichters). U kunt PRO kiezen.",
                "plan.sold_out": "Uitgeput",
                "plan.founder_spots_remaining": "Er zijn slechts {count} plaatsen beschikbaar",
                "plan.founders_occupied": "drukke oprichters",
                "plan.upgrade_not_allowed": "Alleen gebruikers met een GRATIS abonnement kunnen een upgrade aanvragen.",
                'plan.free_contacts': 'Tot 2 contacten',
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "Contacten",
                "billing.usage.chars_month": "Tekens per maand",
                "billing.usage.storage": "Gebruikte opslag",
                "billing.usage.devices": "Verbonden apparaten",
                'billing.loading': 'Laden...',
                'billing.view_plans': 'Plannen bekijken',
                'billing.subscription.section_title': 'Abonnement en facturatie',
                'billing.subscription.provider_note': 'Aanbieder',
                'billing.subscription.paddle_active': 'Paddle (actief plan in de app)',
                'billing.subscription.mp_action_ok': 'Verzoek geregistreerd. Als afrekenen niet opende, controleer uw verbinding of probeer opnieuw.',
                'billing.paddle.manage_subscription_button': 'Abonnement beheren',
                'billing.paddle.portal_confirm_title': 'Facturatieportaal',
                'billing.paddle.portal_confirm': 'Het beveiligde Paddle-portaal opent om betaalmethode, facturen bij te werken of het abonnement op te zeggen. Doorgaan?',
                'billing.paddle.portal_opened_hint': 'Het Paddle-portaal opende in een nieuw tabblad. Vernieuw uw profiel als het plan niet is bijgewerkt.',
                'billing.paddle.portal_error': 'Kan Paddle-portaal niet openen. Probeer later opnieuw of neem contact op met support.',
                'billing.paddle.no_link_error': 'Nog geen Paddle-abonnementskoppeling op uw account. Als u net betaalde, wacht op de webhook of neem contact op met support.',
                'billing.paddle.api_not_configured': 'De server mist Paddle API-configuratie (PADDLE_API_KEY). Een beheerder moet deze instellen.',
                "billing.descriptions.contacts": "Totaal aantal contacten opgeslagen in uw account",
                "billing.descriptions.storage": "Opslag gebruikt voor bestanden en media",
                "billing.descriptions.chars_month": "Karakters vertaald deze maand",
                "billing.descriptions.devices": "Actieve verbonden apparaten",
                'billing.paddle.return_title': 'Betaling ontvangen',
                'billing.paddle.return_body': 'Als u de checkout hebt voltooid, wordt uw plan kort na bevestiging door Paddle bijgewerkt. U kunt naar de startpagina terugkeren.',
                'billing.paddle.verifying': 'Uw plan controleren…',
                'billing.paddle.not_logged_in': 'Meld u aan om de bijgewerkte planstatus te zien.',
                'billing.paddle.plan_updated': 'Plan bijgewerkt: {plan}',
                'billing.paddle.plan_current': 'Uw huidige plan: {plan}',
                'billing.paddle.plan_current_founder': 'U bent nu Founder — {plan}',
                'billing.paddle.still_free_hint': 'Als u na even wachten nog FREE ziet, kan de webhook vertraagd zijn. Controleer de backendlogs of vernieuw deze pagina.',
                'billing.paddle.pro_extra_hint': 'U kunt naar de startpagina gaan om uw plan te gebruiken.',
                "profile.theme.light": "Duidelijke modus",
                "profile.theme.argentina": "Argentinië Thema",
                "avatar.errors.too_large": "De afbeelding is te groot. Maximale grootte: 2 MB.",
                "avatar.preview.title": "Avatar-voorbeeld",
                'profile.avatar.error_title': 'Kon avatar niet bijwerken',
                'profile.avatar.error.title': 'Kon avatar niet bijwerken',
                "profile.avatar.error.size": "De afbeelding overschrijdt de toegestane grootte. Het maximum bedraagt ​​2 MB.",
                "profile.avatar.tooLarge.title": "Afbeelding te groot",
                "profile.avatar.tooLarge.message": "De foto overschrijdt het toegestane formaat. Het maximum bedraagt ​​2 MB.",
                'profile.avatar.uploadError.title': 'Kon avatar niet bijwerken',
                "profile.avatar.uploadError.message": "Er is een probleem opgetreden bij het uploaden van de afbeelding. Probeer het opnieuw.",
                "profile.saveSuccess.title": "Bijgewerkt profiel",
                "profile.saveSuccess.message": "Uw wijzigingen zijn succesvol opgeslagen.",
                "profile.avatar.file_too_large": "De afbeelding overschrijdt de maximaal toegestane grootte (2 MB).",
                "profile.avatar.file_too_large_hint": "Kies een lichtere afbeelding of verklein de afbeelding en probeer het opnieuw.",
                "profile.photo.camera.front": "camera aan de voorkant",
                "profile.photo.camera.back": "achteruitrijcamera",
                "profile.photo.camera.web": "webcam",
                "profile.photo.close": "Dichtbij",
                "contact.favorite.add": "Toevoegen aan favorieten",
                "contact.favorite.remove": "Verwijderen uit favorieten",
                "contact.block.block": "Blok",
                'contact.block.unblock': 'Deblokkeren',
                "conversation.notFound": "Gesprek niet gevonden",
                "help.about.title": "Over",
                "help.about.developer": "Ontwikkeld door:",
                "help.about.location": "MDQ - ARGENTINIË",
                "help.about.linkedin": "Bekijk profiel op LinkedIn",
                'invitation.top.title': 'Top netwerkbouwers',
                'invitation.top.invitesSuffix': 'uitnodigingen',
                "invitation.ranking.position": "Positie",
                "invitation.ranking.user": "Gebruiker",
                'invitation.ranking.validatedInvites': 'Geverifieerde uitnodigingen',
                'invitation.ranking.empty': 'Er zijn geen geverifieerde uitnodigingen om te tonen.',
                'invitation.ranking.loading': 'Ranglijst laden...',
                'invitation.ranking.loadError': 'Kon ranglijst niet laden.',
                "invitations.waitBeforeResend": "Je kunt de uitnodiging nog niet opnieuw verzenden. U moet 10 minuten wachten tussen elke verzending om te voorkomen dat u de gastgebruiker spamt.",
                "invitations.captchaQuestion": "Hoeveel is %1 + %2?",
                "invitations.resendSuccess": "De uitnodiging is succesvol doorgestuurd.",
                "invitations.dailyLimit": "Je hebt vandaag het maximaal toegestane aantal herindieningen bereikt.",
                "invitations.invalidEmail": "De mailserver heeft gemeld dat dit adres ongeldig is.",
                "common.confirm": "Bevestigen",
                "achievement.unlocked": "Prestatie ontgrendeld",
                "achievement.continue": "Doorgaan",
                "plan.errors.chatsLimit.title": "Gesprekslimiet bereikt",
                "plan.errors.chatsLimit.message": "Uw huidige abonnement heeft een limiet op het aantal gesprekken dat u kunt voeren.",
                "plan.errors.chatsLimit.solution": "Upgrade uw abonnement naar PRO om meer gesprekken te starten.",
                "errors.generic": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
                "errors.modal.title": "Fout",
                "errors.modal.copyDetails": "Kopieerdetails",
                "errors.modal.close": "Dichtbij",
                "errors.modal.reportSupport": "Rapporteren aan ondersteuning",
                "errors.avatarTooLarge": "De afbeelding overschrijdt de toegestane grootte van 2 MB.",
                "errors.avatarTooLarge.title": "Afbeelding te groot",
                "errors.avatarTooLarge.message": "De afbeelding overschrijdt de toegestane grootte van 2 MB.",
                "errors.invalidImageType": "Het geselecteerde bestand is geen geldige afbeelding.",
                "errors.invalidImageType.title": "Ongeldig bestand",
                "errors.invalidImageType.message": "Het geselecteerde bestand is geen geldige afbeelding.",
                'errors.uploadFailed': 'Kon afbeelding niet uploaden. Probeer opnieuw.',
                "errors.uploadFailed.title": "Fout bij uploaden",
                'errors.uploadFailed.message': 'Kon afbeelding niet uploaden. Probeer opnieuw.',
                "errors.conversationCreate": "Fout bij maken van gesprek. Probeer het opnieuw.",
                "errors.conversationInvalidId": "Ongeldige gespreks-ID.",
                "errors.conversationOpen": "Fout bij openen van gesprek. Probeer het opnieuw.",
                'errors.favoriteUpdate': 'Kon favoriet niet bijwerken',
                'errors.blockUpdate': 'Kon blokkering niet bijwerken',
                "errors.messageEdit": "Fout bij het bewerken van bericht.",
                "errors.foundation_sold_out": "Founderplekken zijn uitverkocht.",
                'auth.tagline': 'De kracht om begrepen te worden, ongeacht de taal',
                'auth.sign_in': 'Inloggen',
                'auth.create_account': 'Account aanmaken',
                'ui.search_contact': 'Contact zoeken...',
                'ui.language': 'Taal',
                'profile.my_profile': 'Mijn profiel',
                'profile.status': 'Toestand',
                'profile.invite_email': 'Contact per e-mail uitnodigen',
                'profile.sent_invitations': 'Verzonden uitnodigingen',
                "profile.users": "Gebruikers",
                "profile.settings": "Configuratie",
                "profile.appearance": "Verschijning",
                'profile.logout': 'Afmelden',
                "contacts.mode": "Modus",
                "contacts.sent": "Verstuurd",
                "contacts.actions": "Acties",
                "contacts.pending": "Oorbel",
                "contacts.available": "Beschikbaar",
                "contacts.invited_registered": "Gast - Geregistreerd",
                'table.email': 'E-mail',
                'table.language': 'Taal',
                'table.mode': 'Modus',
                "table.status": "Staat",
                'table.sent': 'Verzonden',
                'table.actions': 'Acties',
  'promotions.invite.message': 'Ik nodig je uit voor ArChat – spreek in elke taal. We profiteren er allebei van.',
  'promotions.progress.pending': 'Er zijn openstaande uitnodigingen om beloningen te ontgrendelen.',
  'promotions.progress.in_progress': 'Je uitnodigingen zijn in behandeling: beloningen worden geactiveerd na een echt gesprek.',
  'promotions.progress.remaining': 'U heeft nog {count} gesprekken nodig om uw beloning te ontvangen.',
  'promotions.progress.sent_count': 'Verstuurd',
  'promotions.progress.pending_count': 'In behandeling',
  'promotions.progress.in_progress_count': 'In uitvoering',
  'promotions.progress.completed_count': 'Voltooid',
  'promotions.banner.empty': 'Begin nu: nodig contacten uit en ontgrendel voordelen.',
  'promotions.banner.pending': 'Je hebt openstaande uitnodigingen: voltooi een echt gesprek en verdien beloningen.',
  'promotions.banner.reward': 'Je hebt al beloningen ontgrendeld! Blijf uitnodigen om uw winst te vergroten.',
  'promotions.cta.copy': 'Kopieer bericht en link',
  'promotions.cta.copied': 'Bericht gekopieerd',
  'promotions.cta.copy_error': 'Kan bericht niet kopiëren',

  'promotions.title': 'Promoties en beloningen',
  'promotions.subtitle': 'Nodig contacten uit en ontgrendel voordelen door echt gebruik.',
  'promotions.how_it_works': 'Hoe het werkt',
  'promotions.step1': 'Nodig een contactpersoon uit uw profiel uit.',
  'promotions.step2': 'Wanneer ze echte interactie accepteren en ermee chatten, wordt deze automatisch gevalideerd.',
  'promotions.step3': 'De beloning wordt bijgeschreven en je voortgang wordt bijgewerkt.',
  'promotions.rewards.title': 'Beloningen',
  'promotions.reward.invite': 'Beloning voor elke gevalideerde verwijzing.',
  'promotions.reward.milestone': 'Bonussen voor groeimijlpalen.',
  'promotions.reward.ranking': 'Zichtbaarheid in de ranglijst van topnetwerkbouwers.',
  'promotions.progress.title': 'Jouw voortgang',
  'promotions.progress.sent': 'Verstuurd',
  'promotions.cta.invite': 'Contactpersoon uitnodigen',
  'promotions.banner': 'Activeer promoties: nodig uit en verdien beloningen voor echt gebruik.',
  'promotions.modal.title': 'Promotieprogramma',
  'promotions.modal.body': 'Verdien +10.000 tekens per gevalideerde uitnodiging.\\\\nNodig vandaag nog uit en ontgrendel beloningen.',
  'promotions.modal.cta': 'Bekijk promoties',
                "app.install_ios_hint": "Installeren: Delen > Toevoegen aan startscherm",
                'menu.promotions': 'Promoties',
                'menu.plans': 'Plannen',
                "suggestions.new": "Nieuwe suggestie",
                "suggestions.empty": "U heeft nog geen suggesties ingediend.",
                "suggestions.admin_note": "Teamopmerking",
                "suggestions.status.pending": "Oorbel",
                "suggestions.status.reviewed": "Beoordeeld",
                "suggestions.status.planned": "Gepland",
                "suggestions.status.implemented": "Geïmplementeerd",
                "suggestions.status.rejected": "Afgewezen",
                "referral.promo": "Nodig uit en win 10.000 karakters",
                "referral.stats.sent": "Verstuurd",
                "referral.stats.accepted": "Geaccepteerd",
                "referral.stats.rewards": "Beloningen",
                "referral.reward.pending": "Oorbel",
                "referral.reward.granted": "Gevuld",
                "referral.reward.invalid": "Ongeldig",
                "referral.reward.in_progress": "In gebruik",
                "referral.limit.reached": "Beloningslimiet bereikt",
                "referral.waiting.usage": "+10.000 tekens elk wanneer u en uw gast ten minste één echt sms-bericht verzenden in dezelfde chat (servergevalideerd).",
                "common.avatar": "Avatar",
                "plan.free_characters_month": "30,000 characters / month",
                'plan.pro_characters_month': '300.000 tekens / maand',
                "messages.empty": "Er zijn nog geen berichten",
                "messages.loading": "Berichten laden...",
                "messages.connecting_server": "Verbinding maken met de berichtenserver...",
                "messages.pending_send_count": "{count} bericht(en) in afwachting van bezorging",
                "presence.custom.suggestion.coffee": "Een paar vrienden hebben ☕",
                "presence.custom.suggestion.soccer": "Op het veld ⚽",
                "presence.custom.suggestion.working": "Werken als een gek 💪",
                "presence.custom.suggestion.lunch": "Lunchen 🍽️",
                "presence.custom.suggestion.family": "Familielunch 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "Studeren 📚",
                "presence.custom.suggestion.travel": "Op reis ✈️",
                "presence.custom.suggestion.meeting": "In ontmoeting 💼",
                "presence.custom.suggestion.resting": "Rusten 😴",
                "presence.custom.suggestion.gaming": "Videogames spelen 🎮",
                "presence.custom.suggestion.reading": "Lezen 📖",
                "presence.custom.suggestion.offlineSoon": "Ik ben zo terug ⏳",
                "invitation.safe.phase_notice": "Actieve veilige fase: voordelen in afwachting van commerciële activering (geen echte impact op limieten).",
                "invitation.safe.generate_code": "Genereer link/code",
                "invitation.safe.refresh_top3": "UpdateTop3",
                "invitation.safe.top_loading": "Topuitnodigers laden...",
                "invitation.safe.top_empty": "Er zijn nog geen aanbevolen genodigden.",
                "invitation.safe.hide_full_ranking": "Volledige ranglijst verbergen",
                "invitation.safe.view_full_ranking": "Bekijk de volledige ranglijst",
                "invitation.safe.hide_metrics_dashboard": "Metriekdashboard verbergen",
                "invitation.safe.view_metrics_dashboard": "Bekijk het statistiekendashboard",
                "invitation.safe.prepared_link": "Link voorbereid",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "Registreer in afwachting van uitnodiging",
                "invitation.safe.status_summary": "Statussamenvatting",
                "invitation.safe.summary.pending": "Oorbellen",
                "invitation.safe.summary.registered": "Geregistreerd",
                "invitation.safe.summary.active": "Actief",
                "invitation.safe.summary.validated": "Gevalideerd",
                "invitation.safe.summary.rejected": "Afgewezen",
                "invitation.safe.sent_invitations": "Uitnodigingen uitgegeven",
                "invitation.safe.table.id": "Identiteitskaart",
                "invitation.safe.table.invited_email": "E-mail van gast",
                "invitation.safe.table.code": "Code",
                "invitation.safe.table.status": "Staat",
                "invitation.safe.table.created": "Gemaakt",
                "invitation.safe.empty_sent": "Er zijn nog geen uitnodigingen verzonden.",
                "invitation.safe.simulated_rewards": "Gesimuleerde beloningen verdiend",
                "invitation.safe.empty_rewards": "Voorlopig geen gesimuleerde beloningen.",
                "invitation.safe.error.load_status": "Kan de uitnodigingsstatus niet laden.",
                "invitation.safe.error.generate_code": "De code kan niet worden gegenereerd.",
                "invitation.safe.error.invalid_email": "Voer een geldig e-mailadres in om de uitnodiging te registreren.",
                "invitation.safe.error.register_pending": "De openstaande uitnodiging kan niet worden geregistreerd.",
                "invitation.safe.success.code_generated": "Code gegenereerd.",
                "invitation.safe.success.pending_registered": "In afwachting van uitnodiging geregistreerd in de veilige modus.",
                "invitation.status.deleted": "Uitgeschakeld",
                "invitation.deleted.tooltip": "Deze uitnodiging is verwijderd",
                "invitation.status.rejected": "Afgewezen",
                "invitation.status.bounced": "Gestuiterd",
                "invitation.status.unknown": "Onbekende status",
                "dashboard.admin.title": "Groeistatistieken",
                "dashboard.admin.newUsersToday": "Nieuwe gebruikers vandaag",
                "dashboard.admin.messagesSentToday": "Berichten verzonden vandaag",
                "dashboard.admin.translationsUsed": "Gebruikte vertalingen",
                "dashboard.admin.invitesCreated": "Uitnodigingen gemaakt",
                "dashboard.admin.invitesValidated": "Gevalideerde uitnodigingen",
                "dashboard.admin.inviteConversion": "Conversie van uitnodigingen",
                "dashboard.admin.kFactor": "K-factor",
                "dashboard.admin.newUsers": "Nieuwe gebruikers",
                "dashboard.admin.messagesSent": "Verzonden berichten",
                "dashboard.admin.noData": "Geen gegevens",
                "dashboard.admin.kFactor.viral": "Viraal",
                "dashboard.admin.kFactor.stable": "Stabiel",
                "dashboard.admin.kFactor.low": "Laag",
                "dashboard.admin.emailMetrics": "E-mailstatistieken",
                "dashboard.admin.email.sent": "Verstuurd",
                "dashboard.admin.email.delivered": "Afgeleverd",
                "dashboard.admin.email.opened": "open",
                "dashboard.admin.email.clicked": "Klikken",
                "dashboard.admin.email.bounced": "Gestuiterd",
                "dashboard.admin.email.deliveryRate": "Leveringstarief",
                "dashboard.admin.email.openRate": "Open tarief",
                "dashboard.admin.email.bounceRate": "bouncepercentage",
                "dashboard.admin.funnelMetrics": "Trechterstatistieken",
                "dashboard.admin.funnel.registered": "Geregistreerd",
                "dashboard.admin.funnel.confirmed": "Bevestigd",
                "dashboard.admin.funnel.loggedIn": "Eerst inloggen",
                "dashboard.admin.funnel.firstMessage": "Eerste bericht",
                "dashboard.admin.funnel.abandoned": "Verlaten",
                "dashboard.admin.funnel.conversionRate": "Conversiepercentage",
                "dashboard.admin.funnel.activationRate": "Activeringspercentage",
                "dashboard.admin.funnel.dropoffRate": "Afvalpercentage",
                "dashboard.admin.loading": "Statistieken laden...",
                "dashboard.admin.errorLoad": "Het statistiekendashboard kan niet worden geladen.",
                "dashboard.admin.growthViral": "Virale groei",
                "dashboard.admin.growthStable": "Stabiele groei",
                "dashboard.admin.growthLow": "Lage groei",
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "Code",
                "errors.modal.message": "Bericht",
                "errors.modal.path": "Route",
                "errors.modal.time": "Uur",
                "errors.modal.timestamp": "Tijdstempel",
                "errors.modal.copied": "Gekopieerde details",
                "errors.network": "Kan geen verbinding maken met de server. Controleer uw verbinding.",
                "errors.unexpected": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
                "errors.boundary.title": "REAGEERFOUT VASTGELEGD",
                "errors.boundary.request_id": "X-aanvraag-ID:",
                "errors.boundary.correlate": "Wijs toe aan backend/logs/structured.log",
                "errors.boundary.message_label": "Bericht:",
                "errors.boundary.stack_trace": "Stapeltracering",
                "errors.boundary.component_stack": "componenten stapel",
                "errors.boundary.empty": "(leeg)",
                "errors.boundary.reload_page": "Pagina opnieuw laden",
                "errors.ui_boundary.refresh": "ArChat-interfacefout: pagina opnieuw laden",
                "bootstrap.error.title": "ArChat® — Opstartfout",
                "common.reload": "Opladen",
                "admin.access_denied.message": "Bericht",
                "admin.access_denied.title": "Titel",
                "admin.action.change_plan": "Plan wijzigen",
                "admin.action.reactivate": "Opnieuw activeren",
                "admin.action.suspend": "Opschorten",
                "admin.action.view": "Weergave",
                "admin.confirm.change_plan.message": "Bericht",
                "admin.confirm.change_plan.title": "Titel",
                "admin.confirm.suspend.message": "Bericht",
                "admin.confirm.suspend.title": "Titel",
                "admin.details.created": "Gemaakt",
                "admin.details.current_plan": "Huidig ​​abonnement",
                "admin.details.domain": "Domein",
                "admin.details.last_activity": "Laatste activiteit",
                "admin.details.name": "Yam",
                "admin.details.plan": "Plan",
                "admin.details.status": "Status",
                "admin.details.subscription": "Abonnement",
                "admin.details.tenant_id": "Huurder-ID",
                "admin.details.tenant_info": "Informatie huurder",
                "admin.details.usage": "Gebruik",
                "admin.error.change_plan": "Plan wijzigen",
                "admin.error.generic": "Algemeen",
                "admin.error.load_details": "Details laden",
                "admin.error.load_tenants": "Huurders laden",
                "admin.error.reactivate": "Opnieuw activeren",
                "admin.error.suspend": "Opschorten",
                "admin.error.title": "Titel",
                "admin.filter.active": "Activeren",
                "admin.filter.all_plans": "Alle plannen",
                "admin.filter.all_status": "Alle status",
                "admin.filter.suspended": "Opschorten",
                "admin.limit.devices": "Apparaten",
                "admin.limit.invitations": "Uitnodigingen",
                "admin.limit.messages": "berichten",
                "admin.limit.storage": "Opslag",
                "admin.limit.users": "Gebruikers",
                "admin.loading": "Laden",
                "admin.no_tenants": "Niet-huurders",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "Activeren",
                "admin.status.suspended": "Opschorten",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "Laatste betaling",
                "admin.subscription.status": "Status",
                "admin.subtitle": "Ondertitel",
                "admin.success.plan_changed": "Plan gewijzigd",
                "admin.success.tenant_reactivated": "Huurder gereactiveerd",
                "admin.success.tenant_suspended": "Huurder geschorst",
                "admin.success.title": "Titel",
                "admin.table.actions": "Acties",
                "admin.table.messages": "berichten",
                "admin.table.name": "Yam",
                "admin.table.plan": "Plan",
                "admin.table.status": "Status",
                "admin.table.storage": "Opslag",
                "admin.table.tenant_id": "Huurder-ID",
                "admin.table.users": "Gebruikers",
                "admin.title": "Titel",
                "admin.usage.devices": "Apparaten",
                "admin.usage.invitations": "Uitnodigingen",
                "admin.usage.messages": "berichten",
                "admin.usage.storage": "Opslag",
                "admin.usage.users": "Gebruikers",
                "auth.login": "Login",
                "auth.register": "Register",
                "auth.reset_password": "wachtwoord opnieuw instellen",
                "billing.cancel.button": "knop",
                "billing.cancel.canceling": "Annuleren",
                "billing.cancel.confirm": "Bevestigen",
                "billing.cancel.error": "Fout",
                "billing.cancel.success": "succes",
                "billing.character_billing.characters_used": "Gebruikte karakters",
                "billing.character_billing.consumption_pct": "Verbruik pct",
                "billing.character_billing.days_remaining": "Nog dagen over",
                "billing.character_billing.deletion_date": "Datum van verwijdering",
                "billing.character_billing.period_start": "Begin van de periode",
                "billing.character_billing.renewal_date": "Verlengingsdatum",
                "billing.character_billing.title": "Titel",
                "billing.current_plan": "Huidig ​​abonnement",
                "billing.founder_badge": "Oprichtersbadge",
                "billing.no_plans": "Plan niet",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                'billing.subscription.cancel_scheduled_badge': 'Opzegging op {{date}}',
                'billing.scheduled.plan_after_cancel_label': 'Plan na afloop van de periode:',
                'billing.scheduled.plan_free': 'FREE (gratis)',
                "billing.scheduled.plan_foundation": "FOUNDATION",
                'billing.scheduled.switch_to_foundation': 'Overschakelen naar FOUNDATION',
                'billing.scheduled.switch_to_free': 'Overschakelen naar FREE',
                'billing.scheduled.foundation_full_title': 'FOUNDATION niet beschikbaar',
                'billing.scheduled.foundation_full_message': 'Er zijn momenteel geen FOUNDATION-plaatsen beschikbaar. Je plan wordt aan het einde van de periode gedowngraded naar FREE.',
                'billing.scheduled.saving': 'Opslaan...',
                'billing.scheduled.error_title': 'Fout bij planwijziging',
                'billing.scheduled.error_generic': 'De geplande planwijziging kon niet worden uitgevoerd. Probeer het opnieuw.',
                'billing.cancel_scheduled.title': 'Geplande opzegging',
                'billing.cancel_scheduled.desc': 'Je abonnement wordt opgezegd op {{date}}. Je kunt je huidige plan tot die tijd blijven gebruiken.',
                'billing.cancel_scheduled.no_new_plan_until_end': 'Tot het einde van dit abonnement kun je geen ander plan afsluiten.',
                'billing.cancel_scheduled.free_fallback': 'Als je niet verlengt, gaat je account verder met het FREE-plan met de bijbehorende beperkingen.',
                'billing.cancel_scheduled.profile_deactivation_hint': 'Je kunt je account ook verwijderen vanuit je profiel.',
                'billing.cancel_scheduled.default_free': 'Na afloop van de periode: FREE (gratis)',
                "billing.subscription.next_payment": "Volgende betaling",
                "billing.subscription.plan": "Plan",
                'billing.subscription.price': 'Planprijs',
                "billing.subscription.started": "Gestart",
                "billing.subscription.status": "Status",
                "billing.subscription.mp_flow.subscribe_failed": "Het abonnement kon niet worden gestart. Probeer het opnieuw.",
                "billing.subscription.mp_flow.change_plan_failed": "Het plan kon niet worden gewijzigd. Probeer het opnieuw.",
                "billing.subscription.mp_status.pending": "Oorbel",
                "billing.subscription.mp_status.authorized": "Geautoriseerd",
                "billing.subscription.mp_status.active": "Actief",
                "billing.subscription.mp_status.paused": "Gepauzeerd",
                "billing.subscription.mp_status.cancelled": "Geannuleerd",
                "billing.subscription.mp_status.inactive": "Inactief",
                "billing.subscription.mp_status.unknown": "Een vreemdeling",
                "billing.unlimited": "Onbeperkt",
                "billing.update_plan": "Updateplan",
                "billing.update_plan_modal.title": "Titel",
                "billing.usage.loading": "Laden",
                'common.accept': 'Accepteren',
                "common.confirmPassword": "Wachtwoord bevestigen",
                'common.continue': 'Doorgaan',
                "common.error": "Fout",
                "dashboard.upgrade.to_plan": "Om te plannen",
                "emoji.noResults": "Geen resultaten",
                "emoji.pick": "Kies",
                "export.restricted.message": "Bericht",
                "export.restricted.title": "Titel",
                "export.restricted.upgrade": "Upgraden",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "Q1",
                "help.faq.q2": "Vraag 2",
                "help.faq.q3": "Q3",
                "help.faq.q4": "Q4",
                "help.faq.q5": "Vraag 5",
                "help.faq.q6": "Vraag 6",
                "help.faq.q7": "Vraag 7",
                "help.faq.title": "Titel",
                "help.howWorks.step4.point7": "Punt7",
                "help.message_time_context.free_vs_pro": "Gratis versus pro",
                "help.message_time_context.point5": "Punt5",
                "help.plans.enterprise.benefits": "Voordelen",
                "help.plans.enterprise.description": "Beschrijving",
                "help.plans.enterprise.title": "Titel",
                "help.plans.foundation.devices": "Apparaten",
                "help.plans.free.description": "Beschrijving",
                "help.plans.free.devices": "Apparaten",
                "help.plans.free.limits": "Grenzen",
                "help.plans.free.title": "Titel",
                "help.plans.intro": "Intro",
                "help.plans.pro.benefits": "Voordelen",
                "help.plans.pro.description": "Beschrijving",
                "help.plans.pro.devices": "Apparaten",
                'help.plans.pro.price': '$19 / maand',
                "help.plans.pro.title": "Titel",
                "help.plans.pro.upgrade": "Upgraden",
                "help.plans.title": "Titel",
                "help.plans.urgent_slots_badge": "Dringende slots-badge",
                "help.slogan.final": "Einde",
                "help.suggestions.point1": "Punt1",
                "help.suggestions.point2": "Punt2",
                "help.suggestions.title": "Titel",
                "invitation.already_contact_added": "Reeds contactpersoon toegevoegd",
                "invitation.already_contact_title": "Titel al contact",
                "invitation.already_pending": "Reeds in behandeling",
                "invitation.language.invalid": "Ongeldig",
                "message.send": "Versturen",
                "message.sendFile": "Bestand verzenden",
                "messages.conversations": "Gesprekken",
                "messages.no_conversations_subtitle": "Geen ondertiteling voor gesprekken",
                "messages.no_conversations_title": "Geen gesprekstitel",
                "presence.custom.edit": "Bewerking",
                "profile.enrichment.country": "land",
                "profile.enrichment.country.select": "Selecteer",
                "profile.enrichment.description": "Beschrijving",
                "profile.enrichment.org_size": "Org-grootte",
                "profile.enrichment.org_size.placeholder": "plaatshouder",
                "profile.enrichment.save": "Redden",
                "profile.enrichment.skip": "overslaan",
                "profile.enrichment.title": "Titel",
                "profile.enrichment.usage_type.label": "Label",
                "profile.enrichment.usage_type.placeholder": "plaatshouder",
                "profile.founderPosition": "OprichterPositie",
                "settings.confirmations.description": "Beschrijving",
                "settings.confirmations.disable": "Uitzetten",
                "settings.confirmations.title": "Titel",
                "settings.confirmations.updated": "Bijgewerkt",
                "settings.title": "Titel",
                "theme.description": "Beschrijving",
                "google.unavailable_tenant": "Google is niet beschikbaar voor deze tenant.",
                "google.unavailable": "Google is niet beschikbaar.",
                "google.verify_client_id": "Controleer de client-ID in Google Cloud Console.",
                'google.login_aria': 'Inloggen met Google',
                "message.preview_alt": "Voorbeeld",
                "message.image_attachment_alt": "Bijgevoegde afbeelding",
                "profile.avatar.alt": "avatar",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "Topuitnodigers laden...",
                "invitation.top.empty": "Nog geen aanbevolen uitnodigers.",
                "invitation.contacts.title": "Nodig contacten uit",
                "invitation.contacts.safe_phase_note": "Veilige fase actief: lopende voordelen zonder impact op echte limieten.",
                "invitation.contacts.generate_code": "Genereer code/link",
                "invitation.contacts.refresh_top3": "Ververs Top 3",
                "invitation.contacts.hide_full_ranking": "Volledige ranglijst verbergen",
                "invitation.contacts.show_full_ranking": "Toon volledige ranglijst",
                "invitation.contacts.hide_metrics_dashboard": "Metriekdashboard verbergen",
                "invitation.contacts.show_metrics_dashboard": "Metriekdashboard weergeven",
                "invitation.contacts.prepared_link_label": "Voorbereide koppeling:",
                "invitation.contacts.email_placeholder": "e-mail@domein.com",
                "invitation.contacts.register_pending": "Registreer in afwachting van uitnodiging",
                "invitation.contacts.status_summary": "Statusoverzicht",
                "invitation.contacts.sent_invitations": "Uitnodigingen verzonden",
                "invitation.contacts.invited_email": "Uitgenodigde e-mail",
                "invitation.contacts.code": "code",
                "invitation.contacts.no_sent_invitations": "Ik heb nog geen uitnodigingen verzonden.",
                "invitation.contacts.simulated_rewards": "Gesimuleerde beloningen verkregen",
                "invitation.contacts.no_simulated_rewards": "Nog geen gesimuleerde beloningen.",
                "common.id": "Identiteitskaart",
                "common.created": "Gemaakt",
                "plan.pro_contacts": "Hasta 100 contactos por usuario",
                "common.status": "Status",
                "login.prompt_create_account_with_name": "Wil je een account aanmaken met deze naam?",
                "plans.upgrade.title": "Updateplan",
                "plans.upgrade.comparison": "Planvergelijking",
                'plans.upgrade.billing': '',
                "plans.upgrade.cancel_anytime": "Annuleer wanneer je maar wilt",
                "plans.actions.upgrade_pro": "Ga PRO",
                "plans.actions.become_founder": "Word een oprichter",

                'plans.modal.card.current_badge': 'Je huidige abonnement',

                'plans.modal.card.lower_tier': 'Onder je actieve abonnement',

                'plans.modal.card.manage_in_profile': 'Om te wijzigen of op te zeggen: Abonnement en facturering in je profiel.',
                'plans.modal.card.cancel_subscription': 'Abonnement opzeggen',
                'plans.modal.cancel_confirm.title': 'Abonnement opzeggen of beheren',
                'plans.modal.cancel_confirm.body': 'Er opent een nieuw tabblad met het beveiligde Paddle-portaal om betaling, facturen of opzegging te regelen.',
                'plans.modal.cancel_confirm.continue_button': 'Doorgaan',
                'plans.modal.cancel_confirm.back_button': 'Terug',
                'plans.modal.cancel_paddle_fallback.title': 'Je abonnement beheren',
                'plans.modal.cancel_paddle_fallback.body': 'Het Paddle-facturatieportaal opent niet in deze omgeving (bijv. lokale ontwikkeling of nog geen koppeling). Je kunt hier plannen blijven bekijken en vergelijken.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Begrepen',
                "plans.upgrade_required": "Beschikbaar in PRO-abonnement",
                'dashboard.contacts': 'Contacten',
                'dashboard.characters': 'Tekens',
                'dashboard.storage': 'Opslag',
                'dashboard.active_devices': 'Actieve apparaten',
                'dashboard.need_more_resources': 'Meer middelen nodig?',
                'dashboard.upgrade_message': 'Upgrade je plan voor meer contacten, tekens, opslag en actieve apparaten.',
                'dashboard.upgrade_button': 'Upgraden naar PRO',
                'dashboard.upgrade_button_pro': 'Upgraden naar PRO',
                'dashboard.upgrade_button_foundation': 'Upgraden naar FOUNDATION',
                'account.delete.section_title': 'Account verwijderen',
                'account.delete.description': 'Bij het verwijderen van je account worden al je gegevens, berichten, contacten en instellingen permanent gewist. Deze actie kan niet ongedaan worden gemaakt.',
                'account.delete.button': 'Mijn account verwijderen',
                'accountDeletion.title': 'Verwijdering van account en gegevens',
                'accountDeletion.description': 'Vraag de verwijdering van uw ArChat-account en bijbehorende gegevens aan.',
                'accountDeletion.openRequest': 'Verwijdering van account en gegevens aanvragen',
                'account.delete.confirm_title': 'Account verwijderen',
                'account.delete.confirm_message': 'Weet je zeker dat je je account wilt verwijderen? Er wordt een bevestigingsmail gestuurd. De verwijdering is permanent en onomkeerbaar.',
                'account.delete.email_sent_title': 'E-mail verzonden',
                'account.delete.email_sent': 'We hebben je een bevestigingsmail gestuurd. Controleer je inbox en klik op de link om de verwijdering te bevestigen.',
                'account.delete.error': 'Het verzoek kon niet worden verwerkt. Probeer het opnieuw.',
                'account.delete.confirm_page_title': 'Accountverwijdering bevestigen',
                'account.delete.confirm_page_desc': 'Je staat op het punt om je ArChat-account permanent te verwijderen. Al je gegevens, berichten, contacten en instellingen worden gewist. Deze actie kan niet ongedaan worden gemaakt.',
                'account.delete.confirm_final_button': 'Ja, verwijder mijn account permanent',
                'account.delete.cancel_go_back': 'Annuleren en terug',
                'account.delete.done_title': 'Account verwijderd',
                'account.delete.done_message': 'Je account is succesvol verwijderd. Al je gegevens zijn gewist.',
                'account.delete_token_expired': 'De verwijderlink is verlopen of niet meer geldig. Vraag een nieuwe aan via je profiel.',
                'account.delete_token_invalid': 'Ongeldige of ontbrekende verwijderlink.',
                'account.delete_email_failed': 'De bevestigingsmail kon niet worden verzonden. Probeer het later opnieuw.',
                'account.delete_error': 'Fout bij het verwerken van de verwijdering. Probeer het later opnieuw.',
                'account.not_found': 'Account niet gevonden.',
                'attachment.files_disabled.title': 'Planlimiet',
                'attachment.files_disabled.message': 'Je huidige plan bevat geen bestandsverzending. Upgrade je plan om door te gaan.',
                'attachments.recipientFreeBlocked.title': 'Planlimiet',
                'attachments.recipientFreeBlocked.sender': 'Deze gebruiker heeft het Free-abonnement en kan geen bijlagen ontvangen.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} probeerde een bijlage te sturen, maar je {planName}-abonnement staat geen bijlagen toe. Upgrade naar een hoger plan om bestanden te ontvangen.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Plan upgraden',
                'attachment.storage_insufficient_precheck.title': 'Onvoldoende ruimte',
                'attachment.storage_insufficient_precheck.message': 'Het bestand is {fileSizeMb} MB en je hebt slechts {availableMb} MB beschikbaar. Maak ruimte vrij of upgrade je plan.',
                'auth.login.clear_password_lock_after_reset': 'Ik heb mijn wachtwoord al gewijzigd (bijv. op een ander apparaat)',
                'auth.reset_user_not_found': 'We konden geen account vinden dat bij dit e-mailadres hoort. Controleer het adres of maak een nieuw account aan.',
                'auth.signup_disabled': 'Het registreren van nieuwe accounts is tijdelijk uitgeschakeld in deze omgeving.',
                'billing.paddle.cancel_via_portal': 'Abonnement opzeggen',
                'billing.subscription.cancel_scheduled_date': 'Je abonnement wordt opgezegd op {{date}}. Je kunt je huidige plan tot die tijd blijven gebruiken.',
                "dashboard.plan.foundation": "FOUNDATION",
                'home.pricing_link': 'Plannen en prijzen',
                'home.public_footer.aria': 'Juridische links',
                'home.public_nav.aria': 'Hoofdnavigatie van de site',
                'home.public_nav.pricing': 'Prijzen',
                'message.status.sent': 'Verzonden',
                'message.status.delivered': 'Afgeleverd',
                'message.status.failed': 'Niet verzonden',
                'message.status.sending': 'Verzenden…',
                'plan.errors.translationNotAllowed.title': 'Vertaling niet beschikbaar',
                'plan.errors.translationNotAllowed.message': 'Je huidige plan bevat geen automatische vertaling tussen talen.',
                'plan.errors.translationNotAllowed.solution': 'Om automatische vertaling te gebruiken, upgrade je plan.',
                'profile.plan.foundation.description': 'FOUNDATION-plan (Founder): hetzelfde premium-gebruik als PRO, met Founder-programma en beperkte plaatsen (150 plaatsen).',
                'publicPricing.title': 'Plannen en prijzen',
                'publicPricing.subtitle': 'Transparante limieten afgestemd op de abonnements-engine van ArChat. Commerciële prijzen in USD voor internationale checkout (bijv. Paddle).',
                "publicPricing.nav.back_home": "← Thuis",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                'publicPricing.price.free': 'USD 0 / maand',
                'publicPricing.price.foundation': 'USD {price} / maand',
                'publicPricing.price.pro': 'USD {price} / maand',
                'publicPricing.badge.foundation': 'Founder-programma',
                'publicPricing.badge.pro': 'Aanbevolen',
                'publicPricing.cta.start_free': 'Gratis account aanmaken',
                'publicPricing.cta.register_paid': 'Account aanmaken',
                'publicPricing.free.b1': '30.000 tekens per maand per account.',
                'publicPricing.free.b2': 'Tot 2 contacten per gebruiker; tot 2 actieve gesprekken per account.',
                'publicPricing.free.b3': 'Geen bijlagen of opslagruimte; geen gegevensexport.',
                'publicPricing.free.b4': 'Berichtengeschiedenis tot 30 dagen; 1 apparaat per gebruiker.',
                'publicPricing.free.b5': '34 berichten/dag en 1.000 berichten/maand (tenant); tot 20 uitnodigingen per dag.',
                'publicPricing.premium.b1': '300.000 tekens per maand per account; tot 100 contacten per gebruiker.',
                'publicPricing.premium.b2': 'Onbeperkte gesprekken en chats (tenant); 1.667 berichten/dag en 50.000/maand.',
                'publicPricing.premium.b3': 'Tot 50 MB opslag (tenant); tot 3 apparaten per gebruiker.',
                'publicPricing.premium.b4': 'Onbeperkte uitnodigingen (tenant); export, automatische vertaling en bestanden volgens plan.',
                'publicPricing.premium.b5': 'FOUNDATION: hetzelfde technische contract als PRO, plus Founder-programma (150 plaatsen). PRO: standaard premium.',
                'publicPricing.foundation.founder_note': 'Commercieel Founder-programma: beperkte plaatsen van {slots} (zie planoverzicht). Dezelfde PRO-limieten na activering van het abonnement.',
                'publicPricing.same_limits_pro': 'Dezelfde technische limieten als PRO (premium contract).',
                'publicPricing.same_limits_foundation': 'Dezelfde technische limieten als FOUNDATION (premium contract).',
                'publicPricing.commercial_note': 'De functionele limieten komen van PlanConstants / PlanResolver; je account kan plan_limits in de database toepassen. De commerciële facturering gebruikt Paddle (of andere officieel door ArChat aangewezen processors) met USD-prijzen zoals aangegeven.',
                'publicPricing.paddle_hint': 'De checkout met de gekozen processor wordt afgerond binnen de applicatie wanneer facturering is ingeschakeld.',
                'publicPricing.legal.nav_label': 'Juridisch',
                'publicPricing.legal.terms': 'Servicevoorwaarden',
                'publicPricing.legal.privacy': 'Privacybeleid',
                'publicPricing.legal.refund': 'Terugbetalingsbeleid',
                'files.storageUsed': 'Opslag gebruikt',
                'files.planQuota': 'Opslagquotum',
                'files.availableStorage': 'Beschikbaar',
                'files.usagePercent': 'gebruikt',
                'files.unlimited': 'Onbeperkt',
                'files.sentBy': 'Verzonden door',
                'files.unknownUser': 'Gebruiker',
                'files.preview': 'Voorbeeld',
                'files.previewFile': 'Bestandsvoorbeeld',
                'files.previewUnavailable': 'Voorbeeld is niet beschikbaar.',
                'files.previewLoading': 'Voorbeeld laden…',
                'files.openPreview': 'Voorbeeld',
                'files.downloadFile': 'Bestand downloaden',
                'files.downloadFailed': 'Het bestand kon niet worden gedownload. Controleer verbinding en sessie en probeer opnieuw.',
                'files.closePreview': 'Voorbeeld sluiten',
                'files.unsupportedPreview': 'Geen voorbeeld voor dit bestandstype. U kunt de gegevens hieronder bekijken of downloaden.',
                'files.pdfPreviewHelp': 'Deze browser toont de PDF misschien niet ingesloten. Gebruik downloaden om te openen.',
                "files.labelFileType": "Jongen",
                'files.previewForbidden': 'Geen toestemming om dit bestand te bekijken.',
                'files.previewNotFound': 'Bestand is niet beschikbaar of niet meer zichtbaar in uw account.',
                'settings.heading': "Instellingen",
                "settings.dashboard": "Dashboard",
                'settings.dashboardDescription': 'Lokale voorkeuren voor het startpaneel en zichtbare blokken.',
                'settings.dashboardGridHeading': 'Paneelblokken',
                'settings.dashboardShowOnStartDescription': 'Indien aan, opent het dashboard na inloggen in plaats van de contactenlijst.',
                'settings.dashboardBlockWelcome': 'Welkom',
                'settings.dashboardBlockUsage': 'Plangebruik',
                'settings.dashboardBlockFiles': 'Mijn bestanden',
                'settings.dashboardBlockPromotions': 'Acties',
                'settings.dashboardBlockSessions': 'Sessies',
                'settings.dashboardWelcomeDescription': 'Eerste stappen, contact uitnodigen en hulpsnelkoppelingen.',
                'settings.dashboardUsageDescription': 'Gebruik t.o.v. limieten: contacten, tekens, opslag, apparaten.',
                'settings.dashboardFilesDescription': 'Overzicht zichtbare bestanden en ruimte bij Mijn bestanden.',
                'settings.dashboardPromotionsDescription': 'Promotiesamenvatting en koppeling naar het programma.',
                'settings.dashboardSessionsDescription': 'Actieve sessies en apparaten; andere sessies sluiten indien mogelijk.',
                'settings.enabled': 'Aan',
                'settings.disabled': 'Uit',
                'settings.showDashboardOnStart': 'Dashboard tonen na inloggen',
                'settings.showWelcomeBlock': 'Welkomstblok tonen',
                'settings.showPromotionsBlock': 'Promotieblok tonen',
                'settings.showUsageBlock': 'Plangebruik tonen',
                'settings.showRecentConversationsBlock': 'Recente gesprekken tonen (laatste bericht per contact)',
                'settings.showSessionsBlock': 'Actieve sessies tonen',
                'settings.showFilesBlock': 'Overzicht bestanden tonen',
                'settings.dashboardLocalNote': 'Voorkeuren worden in deze browser (lokaal) bewaard tot er een profiel-API is.',
                'settings.appearanceSettings': "Uiterlijk",
                'settings.argentinaTheme': "Argentinië-thema",
                'settings.darkMode': "Donkere modus",
                'settings.language': "Taal",
                'settings.messageSound': "Berichtengeluid",
                'settings.playSoundDescription': "Geluid afspelen bij nieuwe berichten of belangrijke meldingen.",
                'settings.messageSoundEnabled': "Aan",
                'settings.messageSoundDisabled': "Uit",
                'settings.unreadEmailReminderSection': "E-mailoverzicht ongelezen",
                'settings.unreadEmailReminderDescription': "Laat je nieuwe berichten of bestanden langer ongelezen dan hieronder, dan stuurt ArChat één gecombineerde samenvatting (niet per bericht).",
                'settings.unreadEmailReminderToggle': "Stuur mij samenvattingen per e-mail",
                'settings.unreadEmailDelayHours': "Wachttijd voor verzenden (uur)",
                'settings.unreadEmailDelayHint': "1–168 uur (max. een week). De e-mail gebruikt je profieltaal.",
                "settings.accountSettings": "Rekening",
                'settings.deleteAccount': "Account verwijderen",
                'settings.deleteAccountWarning': "Dit is permanent. Uw gegevens, berichten, contacten en instellingen worden volgens het platformproces verwijderd.",
                'settings.deleteMyAccount': "Mijn account verwijderen",
                'subjects.title': 'Onderwerpen',
                'subjects.singular': 'Onderwerp',
                'subjects.plural': 'Onderwerpen',
                'subjects.general': 'Algemeen',
                'subjects.new': 'Nieuw onderwerp',
                'subjects.create': 'Onderwerp aanmaken',
                'subjects.rename': 'Hernoemen',
                'subjects.finish': 'Afronden',
                'subjects.reopen': 'Heropenen',
                'subjects.select': 'Doorgaan',
                "subjects.status.open": "Open",
                'subjects.status.pending': 'In afwachting',
                'subjects.status.finished': 'Afgerond',
                'subjects.limitReached': 'Je hebt de limiet voor actieve onderwerpen in dit gesprek bereikt. Rond een onderwerp af om een nieuw te maken.',
                'subjects.limitReachedFree': 'FREE: maximaal 3 actieve onderwerpen per gesprek. Rond een onderwerp af om een nieuw te maken.',
                'subjects.limitReachedPro': 'PRO: maximaal 5 actieve onderwerpen per gesprek. Rond een onderwerp af om een nieuw te maken.',
                'subjects.limitReachedFoundation': 'FOUNDATION: maximaal 5 actieve onderwerpen per gesprek. Rond een onderwerp af om een nieuw te maken.',
                'subjects.activeLimitsLine': 'Actieve onderwerpen: {current} / {max}',
                'subjects.closedListTitle': 'Gesloten onderwerpen',
                'subjects.viewClosed': 'Gesloten onderwerpen bekijken',
                'subjects.noClosedSubjects': 'Er zijn geen gesloten onderwerpen.',
                'subjects.reopenSubject': 'Heropenen',
                'subjects.reopenedSubjects': 'Heropende onderwerpen',
                'subjects.reopenLimitReached':
                  'Je hebt de limiet voor actieve onderwerpen bereikt. Rond een ander onderwerp af om dit te heropenen.',
                'subjects.ownerOnlyReopen':
                  'Alleen degene die dit onderwerp heeft aangemaakt, kan het heropenen.',
                'subjects.modal.title': 'Onderwerpen van het gesprek',
                'subjects.modal.subtitle': 'Kies of beheer de onderwerpen van dit gesprek.',
                "subjects.contactLabel": "CONTACT:",
                'subjects.ownerOnlyRename': 'Alleen degene die dit onderwerp heeft aangemaakt, kan de naam wijzigen.',
                'subjects.ownerOnlyStateChange': 'Alleen degene die dit onderwerp heeft aangemaakt, kan de status wijzigen.',
                'subjects.createdByOther': 'Dit onderwerp is door de andere partij aangemaakt. Je kunt antwoorden, maar de naam niet wijzigen.',
                'subjects.empty': 'Geen onderwerpen om te tonen.',
                'subjects.noResults': 'Geen onderwerpen gevonden.',
                'subjects.error.generic': 'Actie mislukt. Probeer opnieuw.',
                'subjects.error.featureDisabled': 'Onderwerpen zijn in deze omgeving niet beschikbaar.',
                'subjects.error.duplicateName': 'Er bestaat al een actief onderwerp met die naam.',
                'subjects.error.ownerRequired': 'Je hebt geen rechten om dit onderwerp te wijzigen.',
                'subjects.error.defaultCannotRename': 'Het onderwerp Algemeen kan niet worden hernoemd.',
                'subjects.error.defaultCannotFinish': 'Het onderwerp Algemeen kan niet worden afgerond.',
                'subjects.current': 'Onderwerp',
                'subjects.change': 'Onderwerp wijzigen',
                'subjects.currentLabel': 'Onderwerp:',
                'subjects.changeSubject': 'Onderwerp wijzigen',
                'subjects.closedCannotSend': 'Dit onderwerp is afgerond. Heropen het om nieuwe berichten te versturen.',
                'subjects.selectBeforeSend': 'Kies een onderwerp in het venster om berichten te bekijken en te versturen.',
                'subjects.loadingMessages': 'Berichten voor dit onderwerp laden…',
                'subjects.messageFilterError': 'We konden de berichten voor dit onderwerp niet laden.',
                ...PRESET_LOCALES.nl,
                "message.status.read": "Lezen",
                "profile.security.privacy_note": "Beheer de privacy en veiligheid van uw account.",
                "profile.security.sessions_title": "Actieve sessies",
                "profile.security.current": "Huidige sessie",
                "billing.paddle.test_access_denied_body": "Op deze server zijn de factureringsactiviteiten beperkt (testmodus of testlijst). Als u al met een echt account heeft betaald, moet de betaling in productie worden toegestaan ​​voor alle gebruikers (bijvoorbeeld PAYMENTS_ALLOW_ALL_BILLING_USERS) of moet die beperking worden uitgeschakeld. Neem contact op met ondersteuning.",
                "contacts.viewContactInfo": "Bekijk contactgegevens",
                "contacts.contactInfoTitle": "Contactgegevens",
                "contacts.phone": "Telefoon",
                "contacts.bio": "Biografie",
                "contacts.notProvided": "Niet geïnformeerd",
                "contacts.unread.badge": "Ongelezen berichten",
                "google.missing_client_id": "Inloggen bij Google is niet beschikbaar in deze build: VITE_GOOGLE_CLIENT_ID (of googleClientId per tenant in __ARCHAT_TENANT_CONFIG__) ontbreekt.",
                "reviews.title": "ArChat-recensies",
                "reviews.create_title": "Hoe zou u ArChat beoordelen?",
                "reviews.edit_title": "Bewerk mijn recensie",
                "reviews.comment_placeholder": "Vertel ons over uw ervaring (optioneel)...",
                "reviews.submit_btn": "Beoordeling indienen",
                "reviews.update_btn": "Update",
                "reviews.thank_you": "Bedankt voor uw recensie!",
                "reviews.submitted_message": "Uw mening helpt ons te verbeteren.",
                "reviews.error_select_rating": "Selecteer een beoordeling",
                "reviews.error_generic": "Fout bij het indienen van een beoordeling",
                "reviews.prompt_message": "Vind je ArChat leuk? Laat uw recensie achter!",
                "reviews.rate_now": "Kwalificeer",
                "reviews.later": "Later",
                "reviews.write_review": "Schrijf recensie",
                "reviews.edit_my_review": "Bewerk mijn recensie",
                "reviews.no_reviews": "Er zijn nog geen beoordelingen. Wees de eerste!",
                "reviews.review_singular": "beoordeling",
                "reviews.review_plural": "beoordelingen",
                "reviews.verified": "Geverifieerd",
                "reviews.anonymous": "Anoniem",
                "settings.webPushSection": "Systeemmeldingen (push/PWA)",
                "settings.webPushDescription": "Staat meldingen toe wanneer de app op de achtergrond staat of gesloten is op mobiel. Vereist openbare VAPID-sleutel in de build (VITE_VAPID_PUBLIC_KEY) en sleutels op de server. Activeer browsertoestemming en registreer dit apparaat.",
                "settings.webPushButton": "Activeer pushmeldingen",
                "settings.webPushRegistering": "Registreren…",
                "settings.webPushState.granted": "Toestemming verleend. Als VAPID correct is ingesteld, is het logboek naar de server verzonden.",
                "settings.webPushState.denied": "Toestemming geweigerd. Schakel meldingen voor deze site in uw browserinstellingen in.",
                "settings.webPushState.default": "Tik op de knop om toestemming te vragen en het apparaat te registreren.",
                "settings.webPushState.unsupported": "Deze browser ondersteunt geen pushmeldingen.",
                "settings.webPushVapidMissing": "VITE_VAPID_PUBLIC_KEY ontbreekt in deze frontend-build: kan het push-abonnement niet voltooien.",
                "tags.etiquetas": "etiketten",
                "tags.manageTitle": "Beheer tags",
                "tags.manage": "🏷️Tags",
                "tags.allTags": "Alle labels",
                "tags.confirmDelete": "Deze tag verwijderen?",
                "tags.tagNamePlaceholder": "Tagnaam",
                "tags.create": "Creëren",
                "tags.noTags": "Er zijn geen etiketten. Maak er hierboven één aan.",
                "tags.save": "Houden",
                "tags.edit": "Bewerking",
                "tags.delete": "Elimineren",
                "tags.assignTo": "Toewijzen aan",
                "tags.noTagsToAssign": "Geen etiketten beschikbaar. Maak ze eerst aan.",
                "tags.bgColor": "achtergrondkleur",
                "tags.textColor": "Tekstkleur",
                "tags.selectTag": "Selecteer een etiket",
                "templates.selectTitle": "Sjablonen",
                "templates.noTemplates": "Er zijn geen sjablonen. Maak er hierboven één aan.",
                "templates.manage": "Beheer sjablonen",
                "templates.confirmDelete": "Deze sjabloon verwijderen?",
                "templates.manageTitle": "Beheer sjablonen",
                "templates.titlePlaceholder": "Sjabloontitel",
                "templates.bodyPlaceholder": "Ik heb het sjabloonbericht geschreven...",
                "templates.create": "Sjabloon maken",
                "templates.save": "Houden",
                "templates.edit": "Bewerking",
                "templates.delete": "Elimineren",
}; // translationsNl


